(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pellegrini-ape-sections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('pellegrini-ape')) return;

    class PellegriniApe extends HTMLElement {
      connectedCallback() {
        this._bootFrame = requestAnimationFrame(() => this._init());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this._bootFrame);
        cancelAnimationFrame(this._frame);
        this._abort?.abort();
        this._resizeObserver?.disconnect();
        this._intersectionObserver?.disconnect();
        this._abort = null;
        this._frame = 0;
      }

      _init() {
        if (this._abort || !this.isConnected) return;
        this._stage = this.querySelector('.pape__stage');
        this._vehicle = this.querySelector('.pape__vehicle');
        this._image = this.querySelector('.pape__cutout');
        this._message = this.querySelector('.pape__message');
        this._messageLines = Array.from(this.querySelectorAll('.pape__message-line'));
        this._lastLineClips = [];
        if (!this._stage) return;

        this._abort = new AbortController();
        const signal = this._abort.signal;
        this._reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this._mobile = matchMedia('(max-width: 749px)');
        this._visible = true;
        this._frame = 0;
        this._previewCentered = false;
        this._forwardProgress = 0;
        this._forwardDirection = 1;
        this._lastTransform = null;
        this._lastAnimating = null;
        this._lastClip = null;
        this._displayProgress = null;
        this._lastRenderTime = 0;
        this._viewportWidth = window.innerWidth;
        this._viewportHeight = window.innerHeight;

        const relayout = () => this._schedule();
        window.addEventListener('resize', relayout, { passive: true, signal });
        window.addEventListener('pageshow', relayout, { signal });
        this._reduced.addEventListener('change', () => this._schedule(), { signal });
        this._mobile.addEventListener('change', relayout, { signal });
        window.addEventListener('scroll', () => {
          this._previewCentered = false;
          // Auch große Scrollsprünge müssen das Verlassen nach oben erfassen.
          if (this._canAnimate()) this._schedule();
        }, { passive: true, signal });

        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) relayout();
        }, { signal });

        document.addEventListener('shopify:section:select', (event) => {
          if (event.target.contains(this)) {
            this._previewCentered = true;
            this._schedule();
          }
        }, { signal });
        document.addEventListener('shopify:section:deselect', (event) => {
          if (event.target.contains(this)) {
            this._previewCentered = false;
            this._schedule();
          }
        }, { signal });

        if (this._image) {
          this._image.addEventListener('load', () => this._schedule(), { signal });
        }

        if ('ResizeObserver' in window) {
          this._resizeObserver = new ResizeObserver(() => this._schedule());
          this._resizeObserver.observe(this._stage);
        }
        if ('IntersectionObserver' in window) {
          this._intersectionObserver = new IntersectionObserver((entries) => {
            this._visible = entries[0].isIntersecting;
            this._schedule();
          }, { rootMargin: '120px 0px' });
          this._intersectionObserver.observe(this);
        }

        this._render();
      }

      _canAnimate() {
        return this.dataset.motion === 'true'
          && !this._reduced.matches
          && (!this._mobile.matches || this.dataset.mobileMotion === 'true');
      }

      _schedule() {
        if (this._frame || !this.isConnected) return;
        this._frame = requestAnimationFrame(() => {
          this._frame = 0;
          this._render();
        });
      }

      _forwardPosition(rawProgress, aboveViewport, speed, advance) {
        if (aboveViewport) {
          // Das Banner ist vollständig unsichtbar: links für die Rückkehr starten.
          this._forwardProgress = 0;
          this._forwardDirection = -1;
        } else if (advance) {
          // Nach Rückkehr von oben fährt die Ape auch beim Hochscrollen nach rechts.
          const direction = this._forwardDirection || 1;
          const journey = direction === -1 ? 1 - rawProgress : rawProgress;
          // Früher ankommen, damit die Halteposition noch gut sichtbar ist.
          const candidate = Math.min(1, Math.max(0, journey * (1 + 0.6 * speed)));
          this._forwardProgress = Math.max(this._forwardProgress || 0, candidate);
        }
        return this._forwardProgress || 0;
      }

      _render() {
        if (!this._vehicle) return;
        const stage = this._stage.getBoundingClientRect();
        const vehicleWidth = this._vehicle.getBoundingClientRect().width;
        // Mobile Browserleisten ändern die Höhe während des Scrollens.
        // Erst bei neuer Breite (z. B. Drehen) die Berechnungshöhe erneuern.
        const viewportWidth = window.innerWidth;
        if (!this._mobile.matches || viewportWidth !== this._viewportWidth) {
          this._viewportHeight = window.innerHeight;
          this._viewportWidth = viewportWidth;
        }
        const viewportHeight = this._viewportHeight;
        const enabled = this._canAnimate();
        const motion = enabled && !this._previewCentered;
        const clamp = (value) => Math.min(1, Math.max(0, value));
        const speed = Number(this.dataset.speed) || 1;
        const rawProgress = (viewportHeight * 0.92 - stage.top)
          / (viewportHeight * 0.84 + stage.height);
        let progress = 0.5;
        if (this.dataset.behavior !== 'scrub' && enabled) {
          const heldProgress = this._forwardPosition(
            rawProgress, stage.bottom <= 0, speed, motion
          );
          if (motion) progress = heldProgress;
        } else if (motion) {
          progress = clamp((rawProgress - 0.5) * speed + 0.5);
        }
        // Scrollposition = Ziel; Fahrzeug und Text folgen gemeinsam weich.
        const now = performance.now();
        const elapsed = this._lastRenderTime
          ? Math.min(64, Math.max(0, now - this._lastRenderTime))
          : 16;
        this._lastRenderTime = now;
        let settling = false;
        if (!motion) {
          this._displayProgress = null;
        } else if (
          this._displayProgress === null ||
          stage.bottom <= 0 ||
          stage.top >= viewportHeight
        ) {
          this._displayProgress = progress;
        } else {
          const target = progress;
          const blend = 1 - Math.exp(-elapsed / 100);
          this._displayProgress += (target - this._displayProgress) * blend;
          settling = Math.abs(target - this._displayProgress) > 0.0005;
          if (!settling) this._displayProgress = target;
          progress = this._displayProgress;
        }
        const margin = stage.width * 0.025;
        let start = margin;
        let end = Math.max(start, stage.width - vehicleWidth - margin);

        if (this.dataset.path === 'through') {
          start = -vehicleWidth;
          end = stage.width;
        }

        const x = motion
          ? start + (end - start) * progress
          : (stage.width - vehicleWidth) / 2;
        // Die CSS-Verankerung bleibt mittig; ausschließlich transform bewegt das Bild.
        const offset = x - (stage.width - vehicleWidth) / 2;
        const transform = 'translate3d(-50%, 0, 0) translate3d('
          + offset.toFixed(2) + 'px, 0, 0)';
        if (transform !== this._lastTransform) {
          this._vehicle.style.transform = transform;
          this._lastTransform = transform;
        }
        if (this._message) {
          let revealed = 1;
          if (motion) {
            if (this._mobile.matches) {
              // Auf schmalen Bildschirmen läuft die Freigabe über die obere Wand.
              revealed = progress;
            } else {
              const textBox = this._message.getBoundingClientRect();
              // Die Freigabekante folgt dem Heck der transparenten Fotoebene.
              const rearEdge = x + vehicleWidth * 0.035;
              const textLeft = textBox.left - stage.left;
              revealed = textBox.width > 0
                ? clamp((rearEdge - textLeft) / textBox.width)
                : progress;
            }
            // Exakte Endpunkte, auch bei geänderten Bildgrößen und Fahrstrecken.
            if (progress <= 0) revealed = 0;
            if (progress >= 1) revealed = 1;
          }
          // Der Text kann vor Ende der Fahrt vollständig lesbar sein.
          // 1 bewahrt das bisherige Tempo; höhere Werte verkürzen den Aufbau.
          const textSpeed = Math.min(3, Math.max(1, Number(this.dataset.textSpeed) || 1.5));
          revealed = clamp(revealed * textSpeed);
          if (this.dataset.sequentialText === 'true' && this._messageLines.length) {
            // Jede im Textfeld eingegebene Zeile erhält einen eigenen Abschnitt.
            // Die nächste Zeile beginnt erst, wenn die vorherige vollständig da ist.
            if (this._lastClip !== 'none') {
              this._message.style.clipPath = 'none';
              this._lastClip = 'none';
            }
            const lineCount = this._messageLines.length;
            this._messageLines.forEach((line, index) => {
              const lineProgress = clamp(revealed * lineCount - index);
              const clip = 'inset(0 ' + ((1 - lineProgress) * 100).toFixed(3) + '% 0 0)';
              if (clip !== this._lastLineClips[index]) {
                line.style.clipPath = clip;
                this._lastLineClips[index] = clip;
              }
            });
          } else {
            const clip = 'inset(0 ' + ((1 - revealed) * 100).toFixed(3) + '% 0 0)';
            if (clip !== this._lastClip) {
              this._message.style.clipPath = clip;
              this._lastClip = clip;
            }
          }
        }
        const animating = String(
          motion && this._visible && (settling || (progress > 0 && progress < 1))
        );
        if (animating !== this._lastAnimating) {
          this.dataset.animating = animating;
          this._lastAnimating = animating;
        }
        if (settling) this._schedule();
      }
    }

    customElements.define('pellegrini-ape', PellegriniApe);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pellegrini-blog"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pellegrini-blog-slider')) {
  customElements.define('pellegrini-blog-slider', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.resumeFrame);
      clearTimeout(this.timer);
      this.animation?.cancel();
      this.animation = null;
      this.finishMove = null;
      this.events?.abort();
      this.resizeObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.cards?.forEach(card => {
        card.inert = false;
        card.removeAttribute('aria-hidden');
        this.track.append(card);
      });
      this.classList.remove('pgb--ready');
    }

    initialize() {
      this.track = this.querySelector('.pgb__grid');
      this.viewport = this.querySelector('.pgb__viewport');
      this.controls = this.querySelector('[data-controls]');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.viewAll = this.querySelector('.pgb__all');
      this.status = this.querySelector('[data-status]');
      if (!this.track || !this.viewport) return;
      this.cards = Array.from(this.track.children);
      if (!this.cards.length) return;
      if (!this.orderInitialized) {
        this.shuffleCards();
        this.orderInitialized = true;
      }
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay === 'false';
      this.hovering = false;
      this.inView = false;
      this.animating = false;
      this.suspended = document.hidden;
      this.editorSelected = false;
      this.interval = Math.max(3000, Number(this.dataset.interval) || 5000);
      this.classList.add('pgb--ready');
      this.viewport.scrollLeft = 0;

      this.previous.addEventListener('click', () => this.move(-1, true), options);
      this.next.addEventListener('click', () => this.move(1, true), options);
      this.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        this.hovering = true;
        this.schedule();
      }, options);
      this.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        this.hovering = false;
        this.schedule();
      }, options);
      window.addEventListener('pointermove', event => {
        if (event.pointerType !== 'mouse') return;
        const hovering = this.contains(event.target);
        if (hovering === this.hovering) return;
        this.hovering = hovering;
        this.schedule();
      }, { ...options, passive: true });
      this.addEventListener('focusin', () => this.schedule(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.suspend();
        else this.resume();
      }, options);
      window.addEventListener('pagehide', () => this.suspend(), options);
      window.addEventListener('pageshow', () => this.resume(), options);
      window.addEventListener('blur', () => this.suspend(), options);
      window.addEventListener('focus', () => this.resume(), options);
      this.reducedMotion.addEventListener('change', () => this.update(), options);
      this.viewport.addEventListener('keydown', event => {
        if (event.target !== this.viewport) return;
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1, true);
      }, options);
      this.viewport.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse') return;
        this.touch = { x: event.clientX, y: event.clientY, id: event.pointerId };
        this.schedule();
      }, options);
      this.viewport.addEventListener('pointerup', event => {
        const touch = this.touch;
        this.touch = null;
        if (touch && event.pointerId === touch.id) {
          const dx = event.clientX - touch.x;
          const dy = event.clientY - touch.y;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            this.suppressClickUntil = performance.now() + 500;
            this.move(dx < 0 ? 1 : -1, true);
          }
        }
        this.schedule();
      }, options);
      this.viewport.addEventListener('pointercancel', () => {
        this.touch = null;
        this.schedule();
      }, options);
      this.viewport.addEventListener('click', event => {
        if (performance.now() < (this.suppressClickUntil || 0)) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, { ...options, capture: true });
      this.addEventListener('shopify:block:select', event => {
        const card = this.cards.find(item => item === event.target || item.contains(event.target));
        if (!card) return;
        this.finishMove?.();
        this.editorSelected = true;
        while (this.track.firstElementChild !== card) this.track.append(this.track.firstElementChild);
        this.update();
      }, options);
      this.addEventListener('shopify:block:deselect', () => {
        this.editorSelected = false;
        this.schedule();
      }, options);
      this.resizeObserver = new ResizeObserver(() => {
        this.finishMove?.();
        this.update();
      });
      this.resizeObserver.observe(this.viewport);
      this.visibilityObserver = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.1 });
      this.visibilityObserver.observe(this);
      this.update();
    }

    shuffleCards() {
      if (this.cards.length < 2) return;
      const storageKey = `pellegrini-blog-start:${this.id}`;
      let previousFirst = null;
      try {
        previousFirst = sessionStorage.getItem(storageKey);
      } catch {}
      for (let index = this.cards.length - 1; index > 0; index--) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [this.cards[index], this.cards[randomIndex]] = [this.cards[randomIndex], this.cards[index]];
      }
      if (this.cards[0].dataset.articleId === previousFirst) {
        const otherIndex = 1 + Math.floor(Math.random() * (this.cards.length - 1));
        [this.cards[0], this.cards[otherIndex]] = [this.cards[otherIndex], this.cards[0]];
      }
      this.track.append(...this.cards);
      try {
        sessionStorage.setItem(storageKey, this.cards[0].dataset.articleId);
      } catch {}
    }

    update() {
      this.visibleCount = Math.min(this.cards.length, Number(getComputedStyle(this).getPropertyValue('--pgb-visible')) || 1);
      const focusedCard = this.hasKeyboardFocus() && Array.from(this.track.children).find(card => card.contains(document.activeElement));
      if (focusedCard && Array.from(this.track.children).indexOf(focusedCard) >= this.visibleCount) {
        while (this.track.firstElementChild !== focusedCard) this.track.append(this.track.firstElementChild);
      }
      this.canMove = this.cards.length > this.visibleCount;
      this.previous.hidden = !this.canMove;
      this.next.hidden = !this.canMove;
      this.controls.hidden = !this.canMove && !this.viewAll;
      this.viewport.tabIndex = this.canMove ? 0 : -1;
      Array.from(this.track.children).forEach((card, index) => {
        const visible = index < this.visibleCount;
        card.inert = !visible;
        if (visible) card.removeAttribute('aria-hidden');
        else card.setAttribute('aria-hidden', 'true');
      });
      this.schedule();
    }

    hasKeyboardFocus() {
      const active = document.activeElement;
      return this.contains(active) && active.matches(':focus-visible');
    }

    suspend() {
      this.suspended = true;
      clearTimeout(this.timer);
      cancelAnimationFrame(this.resumeFrame);
      this.hovering = false;
      this.touch = null;
      this.finishMove?.();
    }

    resume() {
      cancelAnimationFrame(this.resumeFrame);
      this.resumeFrame = requestAnimationFrame(() => {
        if (!this.isConnected || document.hidden) return;
        this.suspended = false;
        this.hovering = false;
        this.touch = null;
        this.finishMove?.();
        const bounds = this.getBoundingClientRect();
        this.inView = bounds.bottom > 0 && bounds.top < window.innerHeight &&
          bounds.right > 0 && bounds.left < window.innerWidth;
        this.update();
      });
    }

    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || this.suspended || !this.canMove || this.paused || this.hovering || this.touch ||
          this.animating || this.editorSelected || !this.inView || document.hidden ||
          this.reducedMotion.matches || this.hasKeyboardFocus()) return;
      this.timer = setTimeout(() => this.move(1, false), this.interval);
    }

    move(direction, announce) {
      if (!this.canMove || this.animating) return;
      clearTimeout(this.timer);
      this.animating = true;
      const stride = this.track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
      if (direction < 0) this.track.prepend(this.track.lastElementChild);
      const from = direction > 0 ? 0 : -stride;
      const to = direction > 0 ? -stride : 0;
      let completed = false;
      const finish = () => {
        if (completed) return;
        completed = true;
        if (direction > 0) this.track.append(this.track.firstElementChild);
        this.animation?.cancel();
        this.animation = null;
        this.finishMove = null;
        this.animating = false;
        if (!this.isConnected) return;
        this.update();
        if (announce) this.status.textContent = this.track.firstElementChild.querySelector('.pgb__title').textContent.trim();
      };
      this.finishMove = finish;
      if (this.reducedMotion.matches) {
        finish();
        return;
      }
      this.animation = this.track.animate([
        { transform: `translateX(${from}px)` },
        { transform: `translateX(${to}px)` }
      ], { duration: 450, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' });
      this.animation.finished.then(finish, () => {});
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pellegrini-expertise"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.PellegriniBottleDownloadClick) {
      document.removeEventListener('click', window.PellegriniBottleDownloadClick);
    }

    function loadBottleImage(url) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.decoding = 'async';
        const cleanup = () => {
          clearTimeout(timeout);
          image.onload = null;
          image.onerror = null;
        };
        const timeout = setTimeout(() => {
          cleanup();
          image.src = '';
          reject(new Error('image-timeout'));
        }, 30000);
        image.onload = () => {
          cleanup();
          if (image.naturalWidth && image.naturalHeight) resolve(image);
          else reject(new Error('image-empty'));
        };
        image.onerror = () => {
          cleanup();
          reject(new Error('image-load'));
        };
        image.src = url;
      });
    }

    async function encodeBottleImage(image, mime) {
      const canvas = document.createElement('canvas');
      const scale = Math.min(1, 4096 / Math.max(image.naturalWidth, image.naturalHeight));
      canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
      canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
      try {
        const context = canvas.getContext('2d');
        if (!context) throw new Error('canvas-unavailable');
        if (mime === 'image/jpeg') {
          context.fillStyle = '#ffffff';
          context.fillRect(0, 0, canvas.width, canvas.height);
        }
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        return await new Promise((resolve, reject) => {
          canvas.toBlob(blob => {
            if (blob && blob.size && blob.type === mime) resolve(blob);
            else reject(new Error('image-format'));
          }, mime, 0.95);
        });
      } finally {
        canvas.width = 0;
        canvas.height = 0;
      }
    }

    async function downloadBottle(button) {
      const root = button.closest('[data-pe-root]');
      if (!root || button.disabled || button.dataset.peDownloading === 'true') return;
      let status;
      button.dataset.peDownloading = 'true';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      try {
        status = root.querySelector('[data-pe-status]') || root.querySelector('[data-pe-bottle-status]');
        if (!status) {
          status = document.createElement('span');
          status.className = 'pe-status pe-status--downloads';
          status.dataset.peStatus = '';
          status.dataset.peBottleStatus = '';
          status.setAttribute('role', 'status');
          status.setAttribute('aria-live', 'polite');
          status.setAttribute('aria-atomic', 'true');
          (root.querySelector('.pe-actions') || root).append(status);
        }
        const format = button.dataset.imageFormat === 'png' ? 'png' : 'jpg';
        const mime = format === 'png' ? 'image/png' : 'image/jpeg';
        const basename = (button.dataset.imageFilename || 'Artikel').split('|')[0].trim()
          .replace(/[<>:"/\\|?*\u0000-\u001f\u007f]/g, '-')
          .replace(/\s+/g, '-').replace(/[. ]+$/g, '').slice(0, 100) || 'Artikel';
        status.dataset.error = 'false';
        status.textContent = 'Das Flaschenbild wird vorbereitet …';
        const image = await loadBottleImage(button.dataset.imageUrl);
        const blob = await encodeBottleImage(image, mime);
        if (!button.isConnected) return;
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        try {
          link.href = url;
          link.download = 'Flaschenbild-' + basename + '.' + format;
          link.hidden = true;
          document.body.append(link);
          link.click();
        } finally {
          link.remove();
          setTimeout(() => URL.revokeObjectURL(url), 60000);
        }
        status.textContent = 'Der Download wurde gestartet.';
      } catch (error) {
        if (status) {
          status.dataset.error = 'true';
          status.textContent = 'Das Flaschenbild konnte nicht heruntergeladen werden. Bitte versuchen Sie es erneut.';
        }
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        delete button.dataset.peDownloading;
      }
    }

    window.PellegriniBottleDownloadClick = event => {
      const button = event.target.closest?.('[data-pe-bottle-trigger]');
      if (!button || button.disabled) return;
      event.preventDefault();
      downloadBottle(button);
    };
    document.addEventListener('click', window.PellegriniBottleDownloadClick);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pellegrini-laender-regionen"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pellegrini-country-atlas')) {
    customElements.define('pellegrini-country-atlas', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.fitFrame);
        cancelAnimationFrame(this.wineryFrame);
        this.mapResizeObserver?.disconnect();
        this.controller?.abort();
        this.releaseWineries();
      }
      initialize() {
        this.controller?.abort();
        this.mapResizeObserver?.disconnect();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tabs = Array.from(this.querySelectorAll('.pla__tab'));
        this.panels = Array.from(this.querySelectorAll('.pla__panel'));
        this.dialog = this.querySelector('dialog');
        if (!this.tabs.length || !this.dialog) return;
        this.querySelector('.pla__tabs').setAttribute('role', 'tablist');
        this.tabs.forEach(tab => tab.setAttribute('role', 'tab'));
        this.panels.forEach(panel => panel.setAttribute('role', 'tabpanel'));
        this.setAttribute('data-enhanced', '');
        this.querySelectorAll('[data-zoom]').forEach(button => button.hidden = false);
        const selected = this.tabFromUrl() || this.tabs.find(tab => tab.getAttribute('href') === window.location.hash) || this.tabs[0];
        this.select(selected.dataset.country);
        this.linkWineries();
        const reconnectWineries = () => {
          cancelAnimationFrame(this.wineryFrame);
          this.wineryFrame = requestAnimationFrame(() => { if (this.isConnected) this.linkWineries(); });
        };
        customElements.whenDefined('pellegrini-winery-index').then(() => { if (!options.signal.aborted) reconnectWineries(); });
        document.addEventListener('DOMContentLoaded', reconnectWineries, options);
        document.addEventListener('shopify:section:load', reconnectWineries, options);
        document.addEventListener('shopify:section:reorder', reconnectWineries, options);
        window.addEventListener('popstate', () => this.select((this.tabFromUrl() || this.tabs[0]).dataset.country), options);
        const fit = () => this.scheduleMapFit();
        window.addEventListener('resize', fit, options);
        window.visualViewport?.addEventListener('resize', fit, options);
        if ('ResizeObserver' in window) {
          this.mapResizeObserver = new ResizeObserver(fit);
          this.querySelectorAll('.pla__map-column, .pla__map-tools, .pla__hint').forEach(element => this.mapResizeObserver.observe(element));
          const siteHeader = document.querySelector('.shopify-section--header');
          if (siteHeader) this.mapResizeObserver.observe(siteHeader);
        }
        document.fonts?.ready.then(() => { if (this.isConnected) this.scheduleMapFit(); });
        this.addEventListener('click', event => {
          const tab = event.target.closest('.pla__tab');
          if (tab) { event.preventDefault(); this.select(tab.dataset.country); }
          const zoom = event.target.closest('[data-zoom]');
          if (zoom) this.openMap(zoom.closest('.pla__panel'));
          if (event.target.closest('[data-close]') || event.target === this.dialog) this.dialog.close();
        }, options);
        this.addEventListener('keydown', event => {
          const tab = event.target.closest('.pla__tab');
          if (!tab) return;
          let index = this.tabs.indexOf(tab);
          if (event.key === 'ArrowRight') index = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') index = (index + this.tabs.length - 1) % this.tabs.length;
          else if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = this.tabs.length - 1;
          else if (event.key === ' ') { event.preventDefault(); this.select(tab.dataset.country); return; }
          else return;
          event.preventDefault(); this.select(this.tabs[index].dataset.country); this.tabs[index].focus();
        }, options);
        for (const type of ['pointerover', 'focusin']) this.addEventListener(type, event => this.highlight(event.target.closest('[data-winery]')?.dataset.winery), options);
        for (const type of ['pointerout', 'focusout']) this.addEventListener(type, event => this.highlight(event.relatedTarget instanceof Element ? event.relatedTarget.closest('[data-winery]')?.dataset.winery : null), options);
        this.querySelectorAll('.pla__map-image').forEach(image => {
          const fail = () => { const figure = image.closest('figure'); if (!figure) return; figure.querySelector('.pla__stage').hidden = true; figure.querySelector('.pla__image-error').hidden = false; figure.closest('.pla__map-column').querySelector('[data-zoom]').hidden = true; };
          image.addEventListener('error', fail, options);
          if (image.complete && image.naturalWidth === 0) fail();
        });
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          const panel = event.target.closest('.pla__panel');
          if (panel) this.select(panel.dataset.panel);
          this.highlight(event.detail?.blockId);
        }, options);
      }
      select(country) {
        this.selectedCountry = country;
        this.tabs.forEach(tab => { const active = tab.dataset.country === country; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
        this.panels.forEach(panel => panel.hidden = panel.dataset.panel !== country);
        this.highlight(null);
        this.scheduleMapFit();
        this.syncWineries();
      }
      tabFromUrl() {
        const value = (new URLSearchParams(window.location.search).get('land') || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        const country = value === 'oesterreich' ? 'osterreich' : value === 'suedafrika' ? 'sudafrika' : value;
        return this.tabs.find(tab => tab.dataset.country === country);
      }
      linkWineries() {
        // Link only the next winery overview; another atlas starts a new pair.
        const scope = this.closest('main') || this.parentElement;
        const next = Array.from(scope.querySelectorAll('pellegrini-country-atlas, pellegrini-winery-index')).find(element => this.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING);
        const target = next?.matches('pellegrini-winery-index') && !next.dataset.fixedCountry ? next : null;
        if (target !== this.wineryIndex) {
          this.releaseWineries();
          this.wineryIndex = target;
        }
        if (!target) return;
        this.wineryReadyObserver?.disconnect();
        if (!this.syncWineries()) {
          this.wineryReadyObserver = new MutationObserver(() => { if (this.syncWineries()) this.wineryReadyObserver.disconnect(); });
          this.wineryReadyObserver.observe(target, { childList: true, subtree: true });
        }
      }
      syncWineries() {
        const index = this.wineryIndex;
        if (!index?.isConnected || !index.initialized || index.dataset.fixedCountry) return false;
        const button = Array.from(index.querySelectorAll('[data-country-filter]')).find(item => item.dataset.countryFilter === this.selectedCountry);
        // Use the existing filter so counts, links and URL state stay consistent.
        if (button) {
          if (button.getAttribute('aria-pressed') !== 'true') button.click();
          if (button.getAttribute('aria-pressed') !== 'true') return false;
        } else if (typeof index.update === 'function') {
          // Keep an empty country empty if its last winery is removed later.
          index.country = this.selectedCountry;
          index.update();
          index.writeCountryToUrl?.();
        } else return false;
        index.setAttribute('data-pla-source', this.id);
        const hasSearch = Boolean(index.querySelector('[data-search]'));
        const fields = index.querySelector('[data-fields]');
        index.toggleAttribute('data-pla-hide-toolbar', !hasSearch);
        index.toggleAttribute('data-pla-hide-controls', !hasSearch && (!fields || fields.hidden));
        return true;
      }
      releaseWineries() {
        this.wineryReadyObserver?.disconnect();
        if (this.wineryIndex?.getAttribute('data-pla-source') === this.id) {
          for (const attribute of ['data-pla-source', 'data-pla-hide-toolbar', 'data-pla-hide-controls']) this.wineryIndex.removeAttribute(attribute);
        }
        this.wineryIndex = null;
      }
      scheduleMapFit() {
        cancelAnimationFrame(this.fitFrame);
        this.fitFrame = requestAnimationFrame(() => { if (this.isConnected) this.fitMap(); });
      }
      fitMap() {
        const panel = this.panels.find(item => !item.hidden);
        if (!panel) return;
        const column = panel.querySelector('.pla__map-column');
        if (!window.matchMedia('(min-width: 990px)').matches) {
          column.style.removeProperty('--pla-fitted-width');
          return;
        }
        const stage = column.querySelector('.pla__stage');
        if (stage.hidden) return;
        const tools = column.querySelector('.pla__map-tools');
        const hint = column.querySelector('.pla__hint');
        const top = parseFloat(getComputedStyle(column).top) || 20;
        const toolsHeight = tools.getBoundingClientRect().height + (parseFloat(getComputedStyle(tools).marginBottom) || 0);
        const hintHeight = hint.getBoundingClientRect().height + (parseFloat(getComputedStyle(hint).marginTop) || 0);
        const availableHeight = Math.max(96, window.innerHeight - top - toolsHeight - hintHeight - 20);
        const ratio = Number(stage.dataset.mapWidth) / Number(stage.dataset.mapHeight);
        const width = Math.floor(Math.min(column.getBoundingClientRect().width, availableHeight * ratio));
        // Keep the complete country visible while the longer winery list scrolls.
        const value = width + 'px';
        if (column.style.getPropertyValue('--pla-fitted-width') !== value) column.style.setProperty('--pla-fitted-width', value);
      }
      highlight(id) {
        if (!id) {
          const focused = document.activeElement?.closest('[data-winery]');
          if (focused && this.contains(focused) && focused.getClientRects().length) id = focused.dataset.winery;
        }
        this.querySelectorAll('[data-winery]').forEach(element => element.classList.toggle('is-highlighted', Boolean(id) && element.dataset.winery === id));
      }
      openMap(panel) {
        const clone = panel.querySelector('.pla__stage').cloneNode(true);
        clone.querySelectorAll('.is-highlighted').forEach(element => element.classList.remove('is-highlighted'));
        clone.querySelector('img').loading = 'eager';
        this.dialog.querySelector('.pla__dialog-map').replaceChildren(clone);
        this.dialog.querySelector('.pla__dialog-title').textContent = panel.querySelector('.pla__country-heading').textContent;
        this.dialog.showModal();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pellegrini-main-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pellegrini-collection')) {
    customElements.define('pellegrini-collection', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.orderFilterGroups();
        this.classList.add('pg-enhanced');
        this.positionOpenPanel();
        this.prepareLoadMore();
        this.addEventListener('submit', (event) => this.submitFilters(event), options);
        this.addEventListener('click', (event) => this.handleClick(event), options);
        this.addEventListener('change', (event) => this.handleChange(event), options);
        this.addEventListener('input', (event) => this.handleInput(event), options);
        this.addEventListener('focusin', (event) => { if (event.target.matches('[data-pg-query]')) this.warmSearch(); }, options);
        this.addEventListener('toggle', (event) => this.handleToggle(event), { ...options, capture: true });
        document.addEventListener('click', (event) => {
          const shortcut = event.target.closest('a[data-pg-catalog-search]');
          if (shortcut && !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
            const target = new URL(shortcut.href, window.location.href);
            if (target.origin === window.location.origin && target.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '') && this.focusCatalogSearch()) {
              event.preventDefault(); return;
            }
          }
          if (!this.contains(event.target)) this.closeFilters();
          else if (!event.target.closest('[data-pg-filter]')) this.closeFilters();
        }, options);
        document.addEventListener('keydown', (event) => {
          if (event.key === ' ' && this.contains(event.target) && event.target.matches('[data-pg-load-more]')) {
            event.preventDefault();
            event.target.click();
            return;
          }
          if (event.key !== 'Escape') return;
          const opened = this.querySelector('[data-pg-filter][open]');
          if (opened) {
            event.preventDefault();
            opened.open = false;
            opened.querySelector('summary').focus();
          }
        }, options);
        this.addEventListener('focusout', (event) => {
          const group = event.target.closest('[data-pg-filter][open]');
          // A browser/window losing focus must not discard the current selection.
          if (group && event.relatedTarget && !group.contains(event.relatedTarget)) group.open = false;
        }, options);
        window.addEventListener('resize', () => this.positionOpenPanel(), options);
        window.addEventListener('hashchange', () => this.focusCatalogSearchFromHash(), options);
        window.addEventListener('popstate', () => this.update(new URL(window.location.href), { history: false }), options);
        const initialURL = new URL(window.location.href);
        this.rememberNativeContent(initialURL);
        const priceURL = this.contextPriceURL(initialURL);
        this.syncContextPrice(priceURL);
        this.syncQuery(priceURL);
        if (this.inlineQuery(priceURL) || this.hasContextPrice(priceURL) || priceURL.searchParams.toString() !== initialURL.searchParams.toString()) {
          this.querySelector('[data-pg-results]').hidden = true;
          const focusId = initialURL.hash === '#pellegrini-sortiment-suche' ? this.querySelector('[data-pg-query]')?.id : undefined;
          this.update(priceURL, { replace: true, focusId });
        }
        this.focusCatalogSearchFromHash();
      }

      disconnectedCallback() {
        this.events?.abort();
        this.searchCaches?.forEach(cache => cache.controller?.abort());
        this.searchCaches?.clear();
        this.request?.abort();
        this.cancelLoadMore();
        this.events = null;
        clearTimeout(this.requestTimeout);
      }

      focusCatalogSearchFromHash() {
        if (window.location.hash === '#pellegrini-sortiment-suche') this.focusCatalogSearch();
      }

      focusCatalogSearch() {
        const input = this.querySelector('[data-pg-query]');
        const form = this.querySelector('[data-pg-query-form]');
        if (!input || !form || !input.getClientRects().length) return false;
        this.closeFilters();
        input.focus({ preventScroll: true });
        form.scrollIntoView({ block: 'start', behavior: 'instant' });
        return true;
      }

      closeFilters(except = null) {
        this.querySelectorAll('[data-pg-filter][open]').forEach((group) => {
          if (group !== except) group.open = false;
        });
      }

      orderFilterGroups() {
        const row = this.querySelector('.pg-filter-row');
        if (!row) return;
        const groups = Array.from(row.querySelectorAll('[data-pg-filter]'));
        groups.sort((a, b) => Number(a.dataset.pgOrder || 0) - Number(b.dataset.pgOrder || 0));
        groups.forEach((group) => row.appendChild(group));
        const more = row.querySelector('[data-pg-more]');
        if (more) row.appendChild(more);

      }

      resetDraft(group) {
        group.querySelectorAll('input').forEach((input) => {
          if (input.type === 'checkbox') input.checked = input.defaultChecked;
          else if (input.type === 'search') input.value = '';
          else input.value = input.defaultValue;
          input.setCustomValidity('');
        });
        group.querySelectorAll('[data-pg-option]').forEach((option) => { option.hidden = false; });
        const noOptions = group.querySelector('[data-pg-no-options]');
        if (noOptions) noOptions.hidden = true;
        this.updateSelected(group);
      }

      handleToggle(event) {
        const group = event.target;
        if (!group.matches('[data-pg-filter]')) return;
        if (group.open) {
          this.closeFilters(group);
          this.positionOpenPanel();
        } else this.resetDraft(group);
      }

      positionOpenPanel(group = this.querySelector('[data-pg-filter][open]')) {
        if (!group || window.matchMedia('(max-width: 749px)').matches) return;
        const row = this.querySelector('.pg-filter-row').getBoundingClientRect();
        const trigger = group.querySelector('summary').getBoundingClientRect();
        const panel = group.querySelector('.pg-panel');
        const width = Math.min(360, row.width);
        panel.style.setProperty('--pg-panel-left', `${Math.max(0, Math.min(trigger.left - row.left, row.width - width))}px`);
        panel.style.setProperty('--pg-panel-top', `${trigger.bottom - row.top + 8}px`);
        panel.style.setProperty('--pg-panel-height', `${Math.min(460, Math.max(180, window.innerHeight - trigger.bottom - 24))}px`);
        panel.setAttribute('data-pg-positioned', '');
      }

      handleClick(event) {
        if (event.target.closest('[data-pg-query-clear]')) {
          event.preventDefault();
          const url = new URL(this.pendingQueryURL || this.pendingPriceURL || window.location.href);
          url.searchParams.delete('pg_q'); url.searchParams.delete('q'); url.searchParams.delete(this.dataset.pageParam || 'page');
          this.update(url, { focusId: this.querySelector('[data-pg-query]')?.id }); return;
        }
        if (event.target.closest('[data-pg-query-retry]') && this.pendingQueryURL) {
          this.update(new URL(this.pendingQueryURL)); return;
        }
        const priceReset = event.target.closest('[data-pg-price-reset]');
        if (priceReset) {
          event.preventDefault();
          const url = new URL(this.pendingPriceURL || window.location.href);
          ['pg_price_min', 'pg_price_max', 'filter.v.price.gte', 'filter.v.price.lte', this.dataset.pageParam || 'page'].forEach(key => url.searchParams.delete(key));
          this.closeFilters();
          this.update(url);
          return;
        }
        if (event.target.closest('[data-pg-price-retry]') && this.pendingPriceURL) {
          this.update(new URL(this.pendingPriceURL));
          return;
        }
        const summary = event.target.closest('[data-pg-filter] > summary');
        if (summary && !summary.parentElement.open) this.positionOpenPanel(summary.parentElement);
        const loadMore = event.target.closest('a[data-pg-load-more]');
        if (loadMore) {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.loadMore(loadMore);
          return;
        }
        const more = event.target.closest('[data-pg-more]');
        if (more) {
          const expanded = this.classList.toggle('pg-expanded');
          more.setAttribute('aria-expanded', String(expanded));
          more.textContent = expanded ? 'Weniger Filter' : more.dataset.moreLabel;
          return;
        }
        const close = event.target.closest('[data-pg-close]');
        if (close) {
          const group = close.closest('[data-pg-filter]');
          group.open = false;
          group.querySelector('summary').focus();
          return;
        }
        const link = event.target.closest('a[data-pg-link]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const url = new URL(link.href, window.location.href);
        if (url.origin !== window.location.origin) return;
        event.preventDefault();
        const group = link.closest('[data-pg-filter]');
        const resetPrice = group?.querySelector('[data-pg-context-price]') && link.hasAttribute('data-pg-group-reset');
        for (const key of ['pg_price_min', 'pg_price_max']) {
          url.searchParams.delete(key);
          const value = new URL(this.pendingPriceURL || window.location.href).searchParams.get(key);
          if (!resetPrice && !link.hasAttribute('data-pg-clear') && value !== null) url.searchParams.set(key, value);
        }
        const stateURL = new URL(this.pendingQueryURL || this.pendingPriceURL || window.location.href);
        for (const key of ['pg_q', 'sort_by', 'preview_theme_id']) {
          if (stateURL.searchParams.has(key)) url.searchParams.set(key, stateURL.searchParams.get(key));
        }
        const focusId = group?.querySelector('summary').id;
        this.closeFilters();
        url.searchParams.delete(this.dataset.pageParam || 'page');
        this.update(url, { focusId });
      }

      handleChange(event) {
        if (event.target.matches('[data-pg-sort]')) {
          this.closeFilters();
          this.querySelectorAll('[data-pg-filter]').forEach((group) => this.resetDraft(group));
          this.update(this.formURL(), { focusId: event.target.id });
        } else if (event.target.matches('input[type="checkbox"]')) {
          this.updateSelected(event.target.closest('[data-pg-filter]'));
        }
      }

      updateSelected(group) {
        const label = group?.querySelector('[data-pg-selected]');
        if (label) label.textContent = `${group.querySelectorAll('input[type="checkbox"]:checked').length} ausgewählt`;
      }

      handleInput(event) {
        const input = event.target;
        if (input.matches('[data-pg-query]')) {
          if (input.value.trim()) this.warmSearch();
          const clear = this.querySelector('.pg-catalog-clear'); if (clear) clear.hidden = !input.value;
          if (!input.value && this.inlineQuery(new URL(this.pendingQueryURL || window.location.href))) this.update(this.queryURL(), { focusId: input.id });
          return;
        }
        if (input.matches('[data-pg-min], [data-pg-max]')) this.validatePrice(input.closest('[data-pg-price-range]'));
        if (!input.matches('[data-pg-search]')) return;
        const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
        const query = normalize(input.value.trim());
        const group = input.closest('[data-pg-filter]');
        let visible = 0;
        group.querySelectorAll('[data-pg-option]').forEach((option) => {
          option.hidden = !normalize(option.dataset.label).includes(query);
          if (!option.hidden) visible += 1;
        });
        group.querySelector('[data-pg-no-options]').hidden = visible > 0;
      }

      validatePrice(range) {
        const min = range.querySelector('[data-pg-min]');
        const max = range.querySelector('[data-pg-max]');
        max.setCustomValidity(min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value)
          ? 'Der Höchstpreis muss mindestens so hoch wie der Mindestpreis sein.' : '');
      }

      formURL() {
        const form = this.querySelector('[data-pg-form]');
        const url = new URL(this.pendingQueryURL || this.pendingPriceURL || window.location.href);
        // Preserve locale, preview_theme_id, tracking and other non-filter parameters.
        for (const key of [...url.searchParams.keys()]) {
          if (key.startsWith('filter.') || key === 'pg_price_min' || key === 'pg_price_max' || key === 'sort_by' || key === 'section_id' || key === 'sections' || key === (this.dataset.pageParam || 'page')) url.searchParams.delete(key);
        }
        // Keep active URL filters if filtering has been deliberately hidden in the editor.
        if (!form.querySelector('[data-pg-filter]')) {
          for (const [key, value] of new URL(window.location.href).searchParams) {
            if (key.startsWith('filter.')) url.searchParams.append(key, value);
          }
        }
        for (const [key, value] of new FormData(form)) {
          if (String(value).trim() === '') continue;
          if (key.startsWith('filter.')) url.searchParams.append(key, value);
          else url.searchParams.set(key, value);
        }
        url.hash = '';
        return url;
      }

      queryURL() {
        const url = new URL(this.pendingQueryURL || this.pendingPriceURL || window.location.href);
        for (const key of ['q', 'page', this.dataset.pageParam || 'page', 'section_id', 'sections']) url.searchParams.delete(key);
        const query = this.querySelector('[data-pg-query]')?.value.trim() || '';
        if (query) url.searchParams.set('pg_q', query); else url.searchParams.delete('pg_q');
        url.hash = ''; return url;
      }

      submitFilters(event) {
        if (event.target.matches('[data-pg-query-form]')) {
          event.preventDefault();
          const url = this.queryURL();
          this.closeFilters();
          this.update(url);
          return;
        }
        if (!event.target.matches('[data-pg-form]')) return;
        event.preventDefault();
        event.target.querySelectorAll('[data-pg-price-range]').forEach((range) => this.validatePrice(range));
        if (!event.target.reportValidity()) return;
        const url = this.formURL();
        const focusId = event.submitter?.closest('[data-pg-filter]')?.querySelector('summary').id;
        this.closeFilters();
        this.update(url, { focusId });
      }

      inlineQuery(url) {
        return this.querySelector('[data-pg-query-form]') ? (url.searchParams.get('pg_q') || '').trim() : '';
      }

      syncQuery(url) {
        const input = this.querySelector('[data-pg-query]');
        if (input) input.value = url.searchParams.get('pg_q') || '';
        const clear = this.querySelector('.pg-catalog-clear');
        if (clear) clear.hidden = !input?.value;
        const error = this.querySelector('[data-pg-query-error]');
        if (error) error.hidden = true;
      }

      searchText(value) {
        return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('de').replace(/ß/g, 'ss');
      }

      searchWords(text) {
        return Array.from(new Set(text.match(/[\p{L}\p{N}]+/gu) || []));
      }

      searchLargeFormat(value, allowBareLiters = false) {
        // Compare bottle volume, never the total volume of a multi-bottle pack.
        const text = this.searchText(value).trim().replace(/(\d)\s*[x×]\s*(?=\d)/gu, '$1 × ');
        if (allowBareLiters && /^\d+(?:[.,]\d+)?$/.test(text)) return Number(text.replace(',', '.')) > 1;
        const amounts = text.matchAll(/(?:^|[^\p{L}\p{N}.,+\-])(\d+(?:[.,]\d+)?)\s*-?\s*(ml|cl|liter|liters|litres?|ltr\.?|l)(?=$|[^\p{L}\p{N}])/gu);
        for (const amount of amounts) {
          const liters = Number(amount[1].replace(',', '.')) / (amount[2] === 'ml' ? 1000 : amount[2] === 'cl' ? 100 : 1);
          if (liters > 1) return true;
        }
        return false;
      }

      searchTypoDistance(term, word, limit) {
        if (term === word) return 0;
        if (Math.abs(term.length - word.length) > limit) return limit + 1;
        let beforePrevious;
        let previous = Array.from({ length: word.length + 1 }, (_, index) => index);
        for (let row = 1; row <= term.length; row += 1) {
          const current = new Array(word.length + 1).fill(limit + 1);
          current[0] = row;
          let rowMinimum = limit + 1;
          for (let column = Math.max(1, row - limit); column <= Math.min(word.length, row + limit); column += 1) {
            current[column] = Math.min(
              previous[column] + 1,
              current[column - 1] + 1,
              previous[column - 1] + (term[row - 1] === word[column - 1] ? 0 : 1)
            );
            if (row > 1 && column > 1 && term[row - 1] === word[column - 2] && term[row - 2] === word[column - 1]) {
              current[column] = Math.min(current[column], beforePrevious[column - 2] + 1);
            }
            rowMinimum = Math.min(rowMinimum, current[column]);
          }
          if (rowMinimum > limit) return limit + 1;
          beforePrevious = previous;
          previous = current;
        }
        return previous[word.length];
      }

      searchAlternatives(cache, term) {
        const matches = new Set();
        // Keep short codes, article numbers and vintages exact.
        if (!/^\p{L}{4,40}$/u.test(term)) return matches;
        if (!cache.typoVocabulary) {
          cache.makerCodes = new Set(cache.records.map(item => this.searchText(item.c).trim()).filter(Boolean));
          cache.typoVocabulary = new Map();
          for (const item of cache.records) {
            for (const word of item.words) {
              if (!/^\p{L}{4,40}$/u.test(word) || cache.makerCodes.has(word)) continue;
              if (!cache.typoVocabulary.has(word.length)) cache.typoVocabulary.set(word.length, new Set());
              cache.typoVocabulary.get(word.length).add(word);
            }
          }
        }
        if (cache.makerCodes.has(term)) return matches;
        const limit = term.length >= 8 ? 2 : 1;
        for (let length = term.length - limit; length <= term.length + limit; length += 1) {
          for (const word of cache.typoVocabulary.get(length) || []) {
            if (this.searchTypoDistance(term, word, limit) <= limit) matches.add(word);
          }
        }
        return matches;
      }

      searchMatches(cache, terms, bounds) {
        const largeFormat = terms.includes('magnum');
        const textTerms = largeFormat ? terms.filter(term => term !== 'magnum') : terms;
        const records = largeFormat ? cache.records.filter(item => item.isLargeFormat) : cache.records;
        const withinPrice = item => (bounds.min === null || item.p >= bounds.min) && (bounds.max === null || item.p <= bounds.max);
        const exact = records.filter(item => textTerms.every(term => item.text.includes(term)));
        // Only offer typo matches when the selected collection and bottle sizes have no exact text matches.
        if (exact.length || !textTerms.length) return exact.filter(withinPrice);
        const alternatives = textTerms.map(term => this.searchAlternatives(cache, term));
        if (!alternatives.some(words => words.size)) return [];
        return records.filter(item => withinPrice(item) && textTerms.every((term, index) =>
          item.text.includes(term) || item.words.some(word => alternatives[index].has(word))
        ));
      }

      searchBaseURL(url) {
        const base = new URL(url);
        ['q', 'pg_q', 'pg_price_min', 'pg_price_max', 'sections', 'section_id', this.dataset.pageParam || 'page'].forEach(key => base.searchParams.delete(key));
        // One server order for all four user sort choices. Ordinals and card pages stay aligned.
        base.searchParams.set('sort_by', this.dataset.defaultSort);
        base.searchParams.sort();
        base.hash = ''; return base;
      }

      searchEntry(base) {
        this.searchCaches ||= new Map();
        let cache = this.searchCaches.get(base.href);
        if (cache && !cache.promise && Date.now() - cache.created >= 60000) {
          cache.controller?.abort(); this.searchCaches.delete(base.href); cache = null;
        }
        if (!cache) cache = { key: base.href, created: Date.now(), records: null, promise: null, pages: new Map(), shell: null };
        this.searchCaches.delete(base.href); this.searchCaches.set(base.href, cache);
        while (this.searchCaches.size > 3) {
          const oldest = this.searchCaches.keys().next().value;
          this.searchCaches.get(oldest).controller?.abort(); this.searchCaches.delete(oldest);
        }
        return cache;
      }

      rememberNativeContent(url, content = this.querySelector('[data-pg-content]')) {
        if (!content) return;
        const cache = this.searchEntry(this.searchBaseURL(url));
        const sort = url.searchParams.get('sort_by') || this.dataset.defaultSort;
        const page = Math.max(1, Number(url.searchParams.get(this.dataset.pageParam || 'page')) || 1);
        const copy = content.cloneNode(true);
        if (page === 1 || !cache.shell) { cache.shell = copy; cache.shellSort = sort; cache.shellPage = page; }
        if (sort === this.dataset.defaultSort) {
          if (cache.pages.size >= 30) cache.pages.delete(cache.pages.keys().next().value);
          cache.pages.set(page, copy);
        }
      }

      cachedNativeContent(url) {
        const cache = this.searchCaches?.get(this.searchBaseURL(url).href);
        const page = Math.max(1, Number(url.searchParams.get(this.dataset.pageParam || 'page')) || 1);
        const sort = url.searchParams.get('sort_by') || this.dataset.defaultSort;
        if (!cache?.shell || Date.now() - cache.created >= 60000 || cache.shellSort !== sort || cache.shellPage !== page) return null;
        return cache.shell.cloneNode(true);
      }

      warmSearch() {
        const connection = navigator.connection;
        if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
        const base = this.searchBaseURL(new URL(this.pendingQueryURL || this.pendingPriceURL || window.location.href));
        this.collectionIndex(base).catch(() => {});
      }

      async searchFetch(url, signal) {
        // Each request has its own timeout, also when two card pages load in parallel.
        const controller = new AbortController();
        const abort = () => controller.abort();
        if (signal.aborted) abort(); else signal.addEventListener('abort', abort, { once: true });
        const timeout = setTimeout(abort, 20000);
        try {
          const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const html = await response.text();
          return new DOMParser().parseFromString(html, 'text/html');
        } finally { clearTimeout(timeout); signal.removeEventListener('abort', abort); }
      }

      async loadSearchIndex(base, signal) {
        const readPage = async page => {
          const url = new URL(base);
          url.searchParams.set('section_id', 'pellegrini-collection-search-index');
          url.searchParams.set(this.dataset.pageParam || 'page', String(page));
          const doc = await this.searchFetch(url, signal);
          const element = doc.querySelector('[data-pg-search-index]');
          if (!element) throw new Error('Collection search index missing');
          const data = JSON.parse(element.textContent);
          if (data.page !== page || !Array.isArray(data.products) || !Number.isSafeInteger(data.total) || data.total < 0 || data.total > 25000) throw new Error('Invalid collection index');
          return data;
        };
        const first = await readPage(1);
        const pageCount = Math.max(1, Math.ceil(first.total / 250));
        const batches = [first];
        let nextPage = 2;
        const worker = async () => {
          while (nextPage <= pageCount) {
            const page = nextPage++;
            batches[page - 1] = await readPage(page);
          }
        };
        await Promise.all([worker(), worker(), worker()]);
        const records = [], handles = new Set();
        const wineries = new Map(Array.from(this.querySelectorAll('[data-pg-winery]'), entry => [this.searchText(entry.dataset.code).trim(), entry.dataset.name]));
        for (let i = 0; i < pageCount; i += 1) {
          const batch = batches[i];
          if (!batch || batch.total !== first.total || Boolean(batch.next) !== (i + 1 < pageCount)) throw new Error('Collection changed during search');
          for (const item of batch.products) {
            if (!item.h || typeof item.n !== 'string' || handles.has(item.h) || !Number.isSafeInteger(item.p)) throw new Error('Invalid search product');
            handles.add(item.h);
            const text = this.searchText(item.t + ' ' + (wineries.get(this.searchText(item.c).trim()) || ''));
            const isLargeFormat = this.searchLargeFormat(item.v, true) || this.searchLargeFormat(item.n);
            records.push({ ...item, text, words: this.searchWords(text), isLargeFormat, ordinal: records.length });
          }
        }
        if (records.length !== first.total || signal.aborted) throw new Error('Incomplete collection search');
        return records;
      }

      async collectionIndex(base, signal) {
        const cache = this.searchEntry(base);
        if (!cache.records && !cache.promise) {
          cache.controller = new AbortController();
          cache.promise = this.loadSearchIndex(base, cache.controller.signal).then(records => {
            cache.records = records; cache.created = Date.now(); return cache;
          }).catch(error => {
            cache.controller.abort();
            if (this.searchCaches.get(base.href) === cache) this.searchCaches.delete(base.href);
            throw error;
          }).finally(() => { cache.promise = null; });
        }
        const promise = cache.records ? Promise.resolve(cache) : cache.promise;
        if (!signal) return promise;
        if (signal.aborted) throw new DOMException('Search superseded', 'AbortError');
        // A new term reuses an in-flight index; it cancels only the old consumer.
        return new Promise((resolve, reject) => {
          const abort = () => reject(new DOMException('Search superseded', 'AbortError'));
          signal.addEventListener('abort', abort, { once: true });
          promise.then(value => { signal.removeEventListener('abort', abort); if (!signal.aborted) resolve(value); }, error => { signal.removeEventListener('abort', abort); reject(error); });
        });
      }

      async searchPage(state, page, signal) {
        if (state.cache.pages.has(page)) return state.cache.pages.get(page);
        const url = new URL(state.base);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set(this.dataset.pageParam || 'page', String(page));
        const doc = await this.searchFetch(url, signal);
        const content = doc.getElementById(this.id)?.querySelector('[data-pg-content]');
        if (!content || (!content.querySelector('.pg-grid') && !content.querySelector('.pg-empty'))) throw new Error('Collection cards missing');
        if (signal.aborted) throw new Error('Cancelled search');
        // Bounded memory; cached markup is never shared between customer sessions.
        if (state.cache.pages.size >= 30) state.cache.pages.delete(state.cache.pages.keys().next().value);
        state.cache.pages.set(page, content);
        if (page === 1) { state.cache.shell = content; state.cache.shellSort = this.dataset.defaultSort; state.cache.shellPage = page; }
        return content;
      }

      async searchShell(state, signal) {
        return state.cache.shell || this.searchPage(state, 1, signal);
      }

      async searchCards(state, records, signal) {
        const pages = [...new Set(records.map(item => Math.floor(item.ordinal / state.pageSize) + 1))];
        const cards = new Map();
        let cursor = 0;
        const worker = async () => {
          while (cursor < pages.length) {
            const page = pages[cursor++];
            const content = await this.searchPage(state, page, signal);
            content.querySelectorAll('.pg-grid > product-card').forEach(card => cards.set(card.getAttribute('handle'), card));
          }
        };
        await Promise.all([worker(), worker(), worker()]);
        return records.map(item => {
          const card = cards.get(item.h);
          // Never silently display the wrong result after a concurrent catalogue/price update.
          if (!card || Number(card.dataset.pgPrice) !== item.p) { this.searchCaches.delete(state.base.href); state.cache.controller?.abort(); throw new Error('Search data changed'); }
          return card.cloneNode(true);
        });
      }

      async updateInlineSearch(url, options) {
        this.cancelLoadMore(); this.request?.abort(); clearTimeout(this.requestTimeout);
        const request = new AbortController(); this.request = request;
        const current = () => this.request === request && this.isConnected;
        url.searchParams.delete(this.dataset.pageParam || 'page');
        this.pendingQueryURL = url.href; this.pendingPriceURL = url.href;
        this.contextResults = null; this.inlineResults = null;
        this.syncQuery(url); this.syncContextPrice(url);
        this.setAttribute('aria-busy', 'true');
        // Keep the current cards in place until the new results are ready.
        this.querySelector('[data-pg-results]').hidden = false;
        this.querySelector('[data-pg-price-error]').hidden = true;
        const summary = this.querySelector('[data-pg-query-summary]');
        summary.hidden = true;
        this.querySelector('[data-pg-status]').textContent = 'Die Kollektion wird durchsucht …';
        try {
          const base = this.searchBaseURL(url);
          const state = { base, cache: this.searchEntry(base), matches: [], pageSize: Math.max(1, Number(this.dataset.pageSize) || 24), shown: 0 };
          const [cache, shell] = await Promise.all([this.collectionIndex(base, request.signal), this.searchShell(state, request.signal)]);
          if (!current()) return;
          const terms = this.searchText(this.inlineQuery(url)).split(/\s+/).filter(Boolean);
          const bounds = this.priceBounds(url);
          const matches = this.searchMatches(cache, terms, bounds);
          const sort = url.searchParams.get('sort_by');
          if (sort === 'price-ascending' || sort === 'price-descending') matches.sort((a, b) => (a.p - b.p) * (sort === 'price-descending' ? -1 : 1));
          if (sort === 'title-ascending' || sort === 'title-descending') {
            const collator = new Intl.Collator(document.documentElement.lang || 'de');
            matches.sort((a, b) => collator.compare(a.n, b.n) * (sort === 'title-descending' ? -1 : 1));
          }
          state.cache = cache; state.matches = matches;
          const content = shell.cloneNode(true);
          const cards = await this.searchCards(state, matches.slice(0, state.pageSize), request.signal);
          if (!current()) return;
          // Shopify facet counts describe the collection, not the additional text search.
          content.querySelectorAll('.pg-option-count').forEach(count => { count.hidden = true; });
          const results = content.querySelector('[data-pg-results]');
          const grid = content.querySelector('.pg-grid') || document.createElement('product-list');
          grid.className = 'product-list pg-grid'; grid.id = 'PellegriniProducts-' + this.dataset.sectionId;
          grid.replaceChildren(...cards); results.replaceChildren(grid); results.hidden = false;
          const area = document.createElement('div'); area.className = 'pg-load-more'; area.setAttribute('data-pg-load-more-area', '');
          const more = document.createElement('a'); more.className = 'pg-button'; more.href = url.href; more.textContent = 'Mehr anzeigen'; more.setAttribute('data-pg-load-more', ''); more.setAttribute('aria-controls', grid.id); area.append(more);
          const message = document.createElement('p'); message.className = 'pg-load-more-message'; message.hidden = true; message.setAttribute('data-pg-load-more-message', ''); area.append(message);
          area.hidden = matches.length <= state.pageSize; results.append(area);
          if (!matches.length) {
            const empty = document.createElement('div'); empty.className = 'pg-empty';
            const heading = document.createElement('h2'); heading.textContent = 'Keine passenden Artikel gefunden.'; empty.append(heading);
            const hint = document.createElement('p'); hint.textContent = 'Ändern Sie den Suchbegriff oder entfernen Sie einzelne Filter.'; empty.append(hint);
            const clear = document.createElement('button'); clear.type = 'button'; clear.className = 'pg-button';
            clear.textContent = terms.length ? 'Suchbegriff löschen' : 'Preisfilter zurücksetzen';
            clear.setAttribute(terms.length ? 'data-pg-query-clear' : 'data-pg-price-reset', ''); empty.append(clear); results.prepend(empty);
          }
          const freshSummary = content.querySelector('[data-pg-query-summary]');
          freshSummary.hidden = true; freshSummary.textContent = terms.length ? `${matches.length} Artikel für „${this.inlineQuery(url)}“` : `${matches.length} Artikel in Ihrer Auswahl`;
          this.querySelector('[data-pg-content]').replaceWith(content);
          state.shown = cards.length; this.inlineResults = state;
          this.finishUpdate(url, options);
          this.querySelector('[data-pg-status]').textContent = freshSummary.textContent;
        } catch (error) {
          if (!current()) return;
          request.abort();
          this.querySelector('[data-pg-query-summary]').hidden = true;
          this.querySelector(this.inlineQuery(url) ? '[data-pg-query-error]' : '[data-pg-price-error]').hidden = false;
          this.querySelector('[data-pg-status]').textContent = 'Die Suche konnte nicht vollständig geladen werden. Bitte erneut versuchen.';
        } finally { if (current()) this.setAttribute('aria-busy', 'false'); }
      }

      async bottleDownloadProducts(signal, onProgress = () => {}) {
        const products = new Map();
        const changed = () => new Error('Die Artikelauswahl hat sich geändert. Bitte laden Sie die Seite neu und versuchen Sie es erneut.');
        const collect = cards => {
          if (signal.aborted) throw new DOMException('Download cancelled', 'AbortError');
          for (const card of cards) {
            const id = card.dataset.pgBottleId;
            if (!id || products.has(id)) throw changed();
            products.set(id, { id, title: card.dataset.pgBottleTitle || '', sku: card.dataset.pgBottleSku || '', image: card.dataset.pgBottleImage || '' });
          }
        };
        if (this.inlineResults) {
          const state = this.inlineResults;
          const matches = state.matches.slice();
          for (let offset = 0; offset < matches.length; offset += state.pageSize) {
            collect(await this.searchCards(state, matches.slice(offset, offset + state.pageSize), signal));
            if (this.inlineResults !== state) throw changed();
            onProgress(products.size, matches.length);
          }
        } else if (this.contextResults) {
          collect(this.contextResults.cards);
          onProgress(products.size, products.size);
        } else {
          const url = new URL(window.location.href);
          const pageParam = this.dataset.pageParam || 'page';
          const pageSize = Math.max(1, Number(this.dataset.pageSize) || 24);
          url.hash = ''; url.searchParams.delete('sections');
          url.searchParams.set('section_id', this.dataset.sectionId);
          let expectedTotal = Number(this.querySelector('[data-pg-content]')?.dataset.pgDownloadTotal);
          if (!Number.isInteger(expectedTotal) || expectedTotal < 0 || expectedTotal > 25000) throw changed();
          for (let page = 1; ; page++) {
            url.searchParams.set(pageParam, String(page));
            const doc = await this.searchFetch(url, signal);
            const content = doc.getElementById(this.id)?.querySelector('[data-pg-content]');
            if (!content || Number(content.dataset.pgDownloadPage) !== page || Number(content.dataset.pgDownloadTotal) !== expectedTotal) throw changed();
            const cards = content.querySelectorAll('.pg-grid > product-card');
            if (cards.length !== Math.min(pageSize, expectedTotal - (page - 1) * pageSize)) throw changed();
            collect(cards);
            onProgress(products.size, expectedTotal);
            const more = content.querySelector('[data-pg-load-more]');
            if (!more) {
              if (products.size !== expectedTotal) throw changed();
              break;
            }
            const next = new URL(more.getAttribute('href'), url);
            if (next.origin !== url.origin || next.pathname !== url.pathname || Number(next.searchParams.get(pageParam)) !== page + 1 || products.size >= expectedTotal) throw changed();
          }
        }
        if (signal.aborted) throw new DOMException('Download cancelled', 'AbortError');
        return [...products.values()];
      }

      async loadInlineMore(button) {
        const state = this.inlineResults;
        const request = new AbortController(); this.moreRequest = request;
        const current = () => this.moreRequest === request && this.inlineResults === state && this.isConnected;
        const message = this.querySelector('[data-pg-load-more-message]');
        message.hidden = true; button.setAttribute('aria-disabled', 'true'); button.textContent = 'Artikel werden geladen …';
        try {
          const cards = await this.searchCards(state, state.matches.slice(state.shown, state.shown + state.pageSize), request.signal);
          if (!current()) return;
          this.querySelector('.pg-grid').append(...cards); state.shown += cards.length;
          if (state.shown >= state.matches.length) { button.hidden = true; message.hidden = false; message.textContent = 'Alle passenden Artikel sind geladen.'; }
          if (document.activeElement === button) cards[0]?.querySelector('a[href]')?.focus({ preventScroll: true });
          this.querySelector('[data-pg-status]').textContent = 'Weitere passende Artikel geladen.';
          this.dispatchEvent(new CustomEvent('pellegrini:collection:updated', { bubbles: true }));
        } catch (error) {
          if (!current()) return;
          message.hidden = false; message.textContent = 'Die weiteren Artikel konnten nicht geladen werden. Bitte erneut versuchen.';
        } finally { if (current()) this.cancelLoadMore(); }
      }

      priceBounds(url) {
        const cents = key => {
          const text = url.searchParams.get(key);
          if (text === null || !/^\d+(?:[.,]\d{1,2})?$/.test(text)) return null;
          const value = Math.round(Number(text.replace(',', '.')) * 100);
          return Number.isSafeInteger(value) && value >= 0 ? value : null;
        };
        return { min: cents('pg_price_min'), max: cents('pg_price_max') };
      }

      contextPriceURL(input) {
        const url = new URL(input);
        if (this.querySelector('[data-pg-query-form]') && url.searchParams.has('q')) {
          if (!url.searchParams.has('pg_q')) url.searchParams.set('pg_q', url.searchParams.get('q'));
          url.searchParams.delete('q');
        }
        const enabled = Boolean(this.querySelector('[data-pg-context-price]'));
        for (const [key, nativeKey] of [['pg_price_min', 'filter.v.price.gte'], ['pg_price_max', 'filter.v.price.lte']]) {
          if (!enabled) { url.searchParams.delete(key); continue; }
          if (!url.searchParams.has(key) && url.searchParams.has(nativeKey)) url.searchParams.set(key, url.searchParams.get(nativeKey));
          url.searchParams.delete(nativeKey);
        }
        const bounds = this.priceBounds(url);
        if (bounds.min === null) url.searchParams.delete('pg_price_min');
        if (bounds.max === null) url.searchParams.delete('pg_price_max');
        if (bounds.min !== null && bounds.max !== null && bounds.min > bounds.max) {
          url.searchParams.delete('pg_price_min'); url.searchParams.delete('pg_price_max');
        }
        return url;
      }

      hasContextPrice(url) {
        const { min, max } = this.priceBounds(url);
        return Boolean(this.querySelector('[data-pg-context-price]')) && (min !== null || max !== null);
      }

      syncContextPrice(url) {
        const range = this.querySelector('[data-pg-context-price]');
        if (!range) return;
        const bounds = this.priceBounds(url);
        for (const [name, value] of [['min', bounds.min], ['max', bounds.max]]) {
          const input = range.querySelector(`[data-pg-${name}]`);
          input.disabled = false;
          input.defaultValue = input.value = value === null ? '' : String(value / 100);
        }
        const active = bounds.min !== null || bounds.max !== null;
        const group = range.closest('[data-pg-filter]');
        group.dataset.active = String(active);
        const name = group.querySelector('.pg-filter-name');
        name.querySelector('.pg-badge')?.remove();
        if (active) {
          const badge = document.createElement('span'); badge.className = 'pg-badge'; badge.textContent = '1'; name.append(badge);
        }
        this.querySelector('[data-pg-context-chip]')?.remove();
        let chips = this.querySelector('.pg-active');
        if (chips && !chips.querySelector('.pg-chip')) { chips.remove(); chips = null; }
        if (!active) return;
        if (!chips) {
          chips = document.createElement('div'); chips.className = 'pg-active'; chips.setAttribute('aria-label', 'Aktive Filter');
          const label = document.createElement('span'); label.className = 'pg-active-label'; label.textContent = 'Ihre Auswahl'; chips.append(label);
          const clear = document.createElement('a'); clear.className = 'pg-text-button'; clear.textContent = 'Alle Filter löschen';
          const clearURL = new URL(url);
          for (const key of [...clearURL.searchParams.keys()]) if (key.startsWith('filter.') || key.startsWith('pg_price_') || key === (this.dataset.pageParam || 'page')) clearURL.searchParams.delete(key);
          clear.href = clearURL.href; clear.setAttribute('data-pg-link', ''); clear.setAttribute('data-pg-clear', ''); chips.append(clear);
          this.querySelector('[data-pg-toolbar]').append(chips);
        }
        const chip = document.createElement('a'); chip.className = 'pg-chip'; chip.setAttribute('data-pg-context-chip', ''); chip.setAttribute('data-pg-price-reset', '');
        const resetURL = new URL(url); ['pg_price_min', 'pg_price_max'].forEach(key => resetURL.searchParams.delete(key)); chip.href = resetURL.href;
        const format = value => new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: this.dataset.currency || 'EUR' }).format(value / 100);
        chip.textContent = `Preis: ${bounds.min === null ? 'bis ' + format(bounds.max) : bounds.max === null ? 'ab ' + format(bounds.min) : format(bounds.min) + ' – ' + format(bounds.max)} ×`;
        chip.setAttribute('aria-label', chip.textContent.slice(0, -2) + ' entfernen');
        chips.insertBefore(chip, chips.querySelector('[data-pg-clear]'));
      }

      async updateContextPrice(url, options) {
        this.cancelLoadMore(); this.request?.abort(); clearTimeout(this.requestTimeout);
        const request = new AbortController(); this.request = request;
        this.pendingPriceURL = url.href;
        this.syncContextPrice(url);
        this.setAttribute('aria-busy', 'true');
        this.querySelector('[data-pg-price-error]').hidden = true;
        this.querySelector('[data-pg-status]').textContent = 'Die angezeigten Preise werden geprüft …';
        const bounds = this.priceBounds(url);
        const cards = [], handles = new Set(), pages = new Set();
        let firstContent = null;
        let pageURL = new URL(url);
        pageURL.searchParams.delete(this.dataset.pageParam || 'page');
        pageURL.searchParams.delete('sections');
        try {
          while (pageURL) {
            if (pages.has(pageURL.href)) throw new Error('Repeated collection page');
            pages.add(pageURL.href);
            pageURL.searchParams.set('section_id', this.dataset.sectionId);
            this.requestTimeout = setTimeout(() => request.abort(), 20000);
            const response = await fetch(pageURL, { signal: request.signal, credentials: 'same-origin' });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const html = await response.text();
            if (request !== this.request || !this.isConnected) return;
            clearTimeout(this.requestTimeout);
            const root = new DOMParser().parseFromString(html, 'text/html').getElementById(this.id);
            const content = root?.querySelector('[data-pg-content]');
            if (!content || (!content.querySelector('.pg-grid') && !content.querySelector('.pg-empty'))) throw new Error('Collection data missing');
            if (!firstContent) firstContent = content;
            for (const card of content.querySelectorAll('.pg-grid > product-card')) {
              const raw = card.getAttribute('data-pg-price');
              if (raw === null || raw.trim() === '' || !Number.isSafeInteger(Number(raw))) throw new Error('Context price missing');
              const handle = card.getAttribute('handle');
              if (!handle) throw new Error('Product handle missing');
              if (!handles.has(handle)) { handles.add(handle); cards.push(card); }
            }
            const next = content.querySelector('[data-pg-load-more]');
            if (!next) { pageURL = null; continue; }
            const nextURL = new URL(next.getAttribute('href'), pageURL);
            if (nextURL.origin !== url.origin || nextURL.pathname !== url.pathname) throw new Error('Unexpected collection URL');
            pageURL = new URL(url);
            const nextPage = nextURL.searchParams.get(this.dataset.pageParam || 'page');
            if (!nextPage) throw new Error('Next page missing');
            pageURL.searchParams.set(this.dataset.pageParam || 'page', nextPage);
            pageURL.searchParams.delete('sections');
          }
          if (request !== this.request || !this.isConnected) return;
          // Native facet counts do not include this contextual price constraint.
          firstContent.querySelectorAll('.pg-option-count').forEach(count => { count.hidden = true; });
          const matches = cards.filter(card => {
            const price = Number(card.dataset.pgPrice);
            return (bounds.min === null || price >= bounds.min) && (bounds.max === null || price <= bounds.max);
          });
          const sort = url.searchParams.get('sort_by');
          if (sort === 'price-ascending' || sort === 'price-descending') matches.sort((a, b) => (Number(a.dataset.pgPrice) - Number(b.dataset.pgPrice)) * (sort === 'price-descending' ? -1 : 1));
          const results = firstContent.querySelector('[data-pg-results]');
          const grid = firstContent.querySelector('.pg-grid') || document.createElement('product-list');
          grid.className = 'product-list pg-grid'; grid.id = 'PellegriniProducts-' + this.dataset.sectionId;
          const pageSize = Math.max(1, Number(this.dataset.pageSize) || 24);
          grid.replaceChildren(...matches.slice(0, pageSize));
          results.replaceChildren(grid); results.hidden = false;
          const area = document.createElement('div'); area.className = 'pg-load-more'; area.setAttribute('data-pg-load-more-area', '');
          const more = document.createElement('a'); more.className = 'pg-button'; more.href = url.href; more.textContent = 'Mehr anzeigen'; more.setAttribute('data-pg-load-more', ''); more.setAttribute('aria-controls', grid.id); area.append(more);
          const message = document.createElement('p'); message.className = 'pg-load-more-message'; message.hidden = true; message.setAttribute('data-pg-load-more-message', ''); area.append(message);
          area.hidden = matches.length <= pageSize; results.append(area);
          if (!matches.length) {
            const empty = document.createElement('div'); empty.className = 'pg-empty';
            const heading = document.createElement('h2'); heading.textContent = 'Kein Artikel passt zu diesem Preisbereich.'; empty.append(heading);
            const reset = document.createElement('button'); reset.type = 'button'; reset.className = 'pg-button'; reset.textContent = 'Preisfilter zurücksetzen'; reset.setAttribute('data-pg-price-reset', ''); empty.append(reset); results.prepend(empty);
          }
          this.querySelector('[data-pg-content]').replaceWith(firstContent);
          this.contextResults = { cards: matches, shown: Math.min(pageSize, matches.length), pageSize };
          this.finishUpdate(url, options);
        } catch (error) {
          if (request !== this.request || !this.isConnected) return;
          this.querySelector('[data-pg-results]').hidden = true;
          this.querySelector('[data-pg-price-error]').hidden = false;
          this.querySelector('[data-pg-status]').textContent = 'Die Preisprüfung ist fehlgeschlagen. Bitte erneut versuchen.';
        } finally {
          if (request === this.request) { clearTimeout(this.requestTimeout); this.setAttribute('aria-busy', 'false'); }
        }
      }

      appendContextProducts(button) {
        const state = this.contextResults;
        const cards = state.cards.slice(state.shown, state.shown + state.pageSize);
        this.querySelector('.pg-grid').append(...cards); state.shown += cards.length;
        if (state.shown >= state.cards.length) {
          button.hidden = true;
          const message = this.querySelector('[data-pg-load-more-message]'); message.textContent = 'Alle Artikel dieser Auswahl sind geladen.'; message.hidden = false;
        }
        this.querySelector('[data-pg-status]').textContent = 'Weitere passende Artikel geladen.';
        if (document.activeElement === button) cards[0]?.querySelector('a[href]')?.focus({ preventScroll: true });
        this.dispatchEvent(new CustomEvent('pellegrini:collection:updated', { bubbles: true }));
      }

      prepareLoadMore() {
        this.querySelector('[data-pg-load-more]')?.setAttribute('role', 'button');
      }

      cancelLoadMore() {
        this.moreRequest?.abort();
        this.moreRequest = null;
        clearTimeout(this.moreTimeout);
        const button = this.querySelector('[data-pg-load-more]');
        if (button) {
          button.removeAttribute('aria-disabled');
          button.textContent = 'Mehr anzeigen';
        }
        this.querySelector('.pg-grid')?.removeAttribute('aria-busy');
      }

      async loadMore(button) {
        if (this.moreRequest || this.getAttribute('aria-busy') === 'true') return;
        if (this.inlineResults) { await this.loadInlineMore(button); return; }
        if (this.contextResults) { this.appendContextProducts(button); return; }
        const grid = this.querySelector('.pg-grid');
        const area = this.querySelector('[data-pg-load-more-area]');
        if (!grid || !area) return;
        // Keep the current filters, market, locale and preview parameters.
        const pageParam = this.dataset.pageParam || 'page';
        const url = new URL(window.location.href);
        const nextPage = new URL(button.href, url).searchParams.get(pageParam);
        if (!nextPage) return;
        url.searchParams.set(pageParam, nextPage);
        url.searchParams.delete('sections');
        url.searchParams.set('section_id', this.dataset.sectionId);
        const request = new AbortController();
        this.moreRequest = request;
        const status = this.querySelector('[data-pg-status]');
        const message = area.querySelector('[data-pg-load-more-message]');
        message.hidden = true;
        button.setAttribute('aria-disabled', 'true');
        button.textContent = 'Wird geladen …';
        grid.setAttribute('aria-busy', 'true');
        status.textContent = 'Weitere Artikel werden geladen.';
        this.moreTimeout = setTimeout(() => request.abort(), 15000);
        try {
          const response = await fetch(url.toString(), { signal: request.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const html = await response.text();
          if (request !== this.moreRequest || !this.isConnected) return;
          const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(this.id);
          const freshGrid = fresh?.querySelector('.pg-grid');
          const freshArea = fresh?.querySelector('[data-pg-load-more-area]');
          if (!freshGrid || !freshArea || freshArea.dataset.pgPage !== nextPage || !freshGrid.children.length) {
            throw new Error('Next collection page missing');
          }
          this.rememberNativeContent(url, fresh.querySelector('[data-pg-content]'));
          const cards = Array.from(freshGrid.children);
          const hadFocus = document.activeElement === button;
          grid.append(...cards);
          const next = freshArea.querySelector('[data-pg-load-more]');
          area.dataset.pgPage = freshArea.dataset.pgPage;
          if (next) button.href = next.getAttribute('href');
          else {
            button.hidden = true;
            message.textContent = 'Alle Artikel dieser Auswahl sind geladen.';
            message.hidden = false;
          }
          status.textContent = next ? 'Weitere Artikel geladen.' : 'Alle Artikel dieser Auswahl sind geladen.';
          // Continue keyboard navigation at the newly appended products without scrolling.
          if (hadFocus) {
            const focusTarget = cards[0].querySelector('a[href]') || cards[0];
            if (!focusTarget.matches('a[href]')) focusTarget.setAttribute('tabindex', '-1');
            focusTarget.focus({ preventScroll: true });
          }
          this.dispatchEvent(new CustomEvent('pellegrini:collection:updated', { bubbles: true }));
        } catch (error) {
          if (request !== this.moreRequest || !this.isConnected) return;
          message.textContent = 'Die weiteren Artikel konnten nicht geladen werden. Bitte erneut versuchen.';
          message.hidden = false;
          status.textContent = message.textContent;
        } finally {
          if (request === this.moreRequest) this.cancelLoadMore();
        }
      }

      async update(url, { history = true, focusId, scroll = false, replace = false } = {}) {
        url = this.contextPriceURL(url);
        const options = { history, focusId, scroll, replace };
        this.inlineResults = null;
        if (this.inlineQuery(url) || (this.querySelector('[data-pg-query-form]') && this.hasContextPrice(url))) return this.updateInlineSearch(url, options);
        this.pendingQueryURL = null;
        this.syncQuery(url);
        const cached = this.cachedNativeContent(url);
        if (cached && !this.hasContextPrice(url)) {
          this.cancelLoadMore(); this.request?.abort(); clearTimeout(this.requestTimeout); this.request = null;
          this.querySelector('[data-pg-content]').replaceWith(cached); this.contextResults = null;
          this.finishUpdate(url, options); return;
        }
        if (this.hasContextPrice(url)) {
          url.searchParams.delete(this.dataset.pageParam || 'page');
          return this.updateContextPrice(url, options);
        }
        this.cancelLoadMore();
        this.request?.abort();
        clearTimeout(this.requestTimeout);
        const request = new AbortController();
        this.request = request;
        const requestURL = new URL(url);
        requestURL.searchParams.set('section_id', this.dataset.sectionId);
        this.setAttribute('aria-busy', 'true');
        const status = this.querySelector('[data-pg-status]');
        status.textContent = 'Das Sortiment wird aktualisiert.';
        let timedOut = false;
        this.requestTimeout = setTimeout(() => { timedOut = true; request.abort(); }, 15000);
        try {
          const response = await fetch(requestURL.toString(), { signal: request.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const html = await response.text();
          if (request !== this.request || !this.isConnected) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.getElementById(this.id)?.querySelector('[data-pg-content]');
          if (!fresh) throw new Error('Collection section missing');
          this.querySelector('[data-pg-content]').replaceWith(fresh);
          this.contextResults = null;
          this.rememberNativeContent(url);
          this.finishUpdate(url, options);
        } catch (error) {
          if (request !== this.request || !this.isConnected) return;
          if (error.name === 'AbortError' && !timedOut) return;
          // Normal Shopify navigation remains the reliable fallback.
          window.location.assign(url.toString());
        } finally {
          if (request === this.request) {
            clearTimeout(this.requestTimeout);
            this.setAttribute('aria-busy', 'false');
          }
        }
      }

      finishUpdate(url, { history = true, focusId, scroll = false, replace = false } = {}) {
        this.syncQuery(url);
        const selectedSort = this.querySelector('[data-pg-sort]');
        if (selectedSort) selectedSort.value = url.searchParams.get('sort_by') || this.dataset.defaultSort;
        this.pendingQueryURL = null;
        this.pendingPriceURL = null;
        this.orderFilterGroups(); this.prepareLoadMore(); this.syncContextPrice(url);
        const more = this.querySelector('[data-pg-more]');
        if (more && this.classList.contains('pg-expanded')) { more.setAttribute('aria-expanded', 'true'); more.textContent = 'Weniger Filter'; }
        if (history && url.href !== window.location.href) window.history[replace ? 'replaceState' : 'pushState']({ ...window.history.state, pellegrini: true }, '', url);
        this.setAttribute('aria-busy', 'false');
        const results = this.querySelector('[data-pg-results]');
        this.querySelector('[data-pg-status]').textContent = 'Sortiment aktualisiert.';
        const focusTarget = focusId ? this.querySelector(`#${CSS.escape(focusId)}`) : results;
        (focusTarget || results)?.focus({ preventScroll: true });
        if (scroll) {
          const toolbar = this.querySelector('[data-pg-toolbar]');
          const sticky = getComputedStyle(toolbar).position === 'sticky';
          const offset = sticky ? toolbar.offsetHeight + parseFloat(getComputedStyle(this).getPropertyValue('--pg-sticky-offset')) + 16 : 16;
          window.scrollTo({ top: Math.max(0, window.scrollY + results.getBoundingClientRect().top - offset), behavior: 'instant' });
        }
        this.dispatchEvent(new CustomEvent('pellegrini:collection:updated', { bubbles: true }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pellegrini-main-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pellegrini-retail-price')) {
    customElements.define('pellegrini-retail-price', class extends HTMLElement {
      static get observedAttributes() { return ['data-variant-id']; }

      connectedCallback() {
        this.componentConnected = true;
        this.section = this.closest('.pellegrini-product-section');
        this.onVariantChange = (event) => {
          if (!event.detail || !Object.prototype.hasOwnProperty.call(event.detail, 'variant')) return;
          this.setAttribute('data-variant-id', event.detail.variant?.id || '');
        };
        this.section?.addEventListener('variant:change', this.onVariantChange);
        this.loadPrice();
      }

      disconnectedCallback() {
        this.componentConnected = false;
        this.section?.removeEventListener('variant:change', this.onVariantChange);
        this.cancelRequest();
        this.hidden = true;
      }

      attributeChangedCallback(name, previous, current) {
        if (this.componentConnected && this.isConnected && previous !== current) this.loadPrice();
      }

      cancelRequest() {
        this.requestController?.abort();
        clearTimeout(this.requestTimeout);
        this.requestController = null;
      }

      async loadPrice() {
        this.cancelRequest();
        this.hidden = true;
        const amountElement = this.querySelector('[data-retail-amount]');
        if (!amountElement) return;
        amountElement.textContent = '';
        const domain = this.dataset.shopDomain || '';
        const variantId = String(this.dataset.variantId || '').replace(/^gid:\/\/shopify\/ProductVariant\//, '');
        if (!/^[a-z0-9][a-z0-9-]*\.myshopify\.com$/i.test(domain) || !/^\d+$/.test(variantId)) return;

        const controller = new AbortController();
        this.requestController = controller;
        this.requestTimeout = setTimeout(() => controller.abort(), 8000);
        const gid = `gid://shopify/ProductVariant/${variantId}`;

        try {
          const response = await fetch(`https://${domain}/api/2026-07/graphql.json`, {
            method: 'POST',
            credentials: 'omit',
            cache: 'no-store',
            referrerPolicy: 'no-referrer',
            headers: { 'Content-Type': 'application/json' },
            signal: controller.signal,
            body: JSON.stringify({
              query: 'query PellegriniRetailPrice($variantId: ID!, $country: CountryCode!) @inContext(country: $country) { node(id: $variantId) { ... on ProductVariant { id price { amount currencyCode } } } }',
              variables: { variantId: gid, country: 'DE' }
            })
          });
          if (!response.ok) return;
          const result = await response.json();
          const variant = result.data?.node;
          const price = variant?.price;
          if (result.errors?.length || variant?.id !== gid || result.extensions?.context?.country !== 'DE') return;
          if (price?.currencyCode !== 'EUR' || !/^\d+(\.\d+)?$/.test(String(price.amount ?? ''))) return;
          const amount = Number(price.amount);
          if (!Number.isFinite(amount) || amount <= 0) return;
          if (!this.isConnected || controller.signal.aborted || this.requestController !== controller) return;

          let formatter;
          try {
            formatter = new Intl.NumberFormat(this.dataset.locale || 'de', { style: 'currency', currency: 'EUR' });
          } catch {
            formatter = new Intl.NumberFormat('de', { style: 'currency', currency: 'EUR' });
          }
          amountElement.textContent = formatter.format(amount);
          this.hidden = false;
        } catch {
          if (this.requestController === controller) this.hidden = true;
        } finally {
          if (this.requestController === controller) {
            clearTimeout(this.requestTimeout);
            this.requestController = null;
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pellegrini-main-search"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pellegrini-search')) {
    customElements.define('pellegrini-search', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.orderFilterGroups();
        this.classList.add('pg-enhanced');
        this.positionOpenPanel();
        this.prepareLoadMore();
        this.addEventListener('submit', (event) => this.submitFilters(event), options);
        this.addEventListener('click', (event) => this.handleClick(event), options);
        this.addEventListener('change', (event) => this.handleChange(event), options);
        this.addEventListener('input', (event) => this.handleInput(event), options);
        this.addEventListener('search', (event) => {
          if (event.target.matches('[data-pg-query]') && !event.target.value.trim()) this.handleInput(event);
        }, options);
        this.addEventListener('toggle', (event) => this.handleToggle(event), { ...options, capture: true });
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.closeFilters();
          else if (!event.target.closest('[data-pg-filter]')) this.closeFilters();
        }, options);
        document.addEventListener('keydown', (event) => {
          if (event.key === ' ' && this.contains(event.target) && event.target.matches('[data-pg-load-more]')) {
            event.preventDefault();
            event.target.click();
            return;
          }
          if (event.key !== 'Escape') return;
          const opened = this.querySelector('[data-pg-filter][open]');
          if (opened) {
            event.preventDefault();
            opened.open = false;
            opened.querySelector('summary').focus();
          }
        }, options);
        this.addEventListener('focusout', (event) => {
          const group = event.target.closest('[data-pg-filter][open]');
          // A browser/window losing focus must not discard the current selection.
          if (group && event.relatedTarget && !group.contains(event.relatedTarget)) group.open = false;
        }, options);
        window.addEventListener('resize', () => this.positionOpenPanel(), options);
        window.addEventListener('popstate', () => this.update(new URL(window.location.href), { history: false }), options);
        const initialURL = new URL(window.location.href);
        this.renderedURL = initialURL.href;
        if (!this.querySelector('[data-pg-content]').dataset.pgRenderedQuery) {
          this.update(this.queryURL(), { replace: true, focusId: this.querySelector('[data-pg-query]').id });
          return;
        }
        const priceURL = this.contextPriceURL(initialURL);
        this.syncContextPrice(priceURL);
        if (this.hasContextPrice(priceURL) || priceURL.href !== initialURL.href) {
          this.querySelector('[data-pg-results]').hidden = true;
          this.update(priceURL, { replace: true });
        }
      }

      disconnectedCallback() {
        this.events?.abort();
        this.request?.abort();
        this.cancelLoadMore();
        this.events = null;
        clearTimeout(this.requestTimeout);
        clearTimeout(this.queryTimer);
      }

      closeFilters(except = null) {
        this.querySelectorAll('[data-pg-filter][open]').forEach((group) => {
          if (group !== except) group.open = false;
        });
      }

      orderFilterGroups() {
        const row = this.querySelector('.pg-filter-row');
        if (!row) return;
        const groups = Array.from(row.querySelectorAll('[data-pg-filter]'));
        groups.sort((a, b) => Number(a.dataset.pgOrder || 0) - Number(b.dataset.pgOrder || 0));
        groups.forEach((group) => row.appendChild(group));
        const more = row.querySelector('[data-pg-more]');
        if (more) row.appendChild(more);
        const inlineSort = row.querySelector('.pg-sort--inline');
        if (inlineSort) row.appendChild(inlineSort);
      }

      resetDraft(group) {
        group.querySelectorAll('input').forEach((input) => {
          if (input.type === 'checkbox') input.checked = input.defaultChecked;
          else if (input.type === 'search') input.value = '';
          else input.value = input.defaultValue;
          input.setCustomValidity('');
        });
        group.querySelectorAll('[data-pg-option]').forEach((option) => { option.hidden = false; });
        const noOptions = group.querySelector('[data-pg-no-options]');
        if (noOptions) noOptions.hidden = true;
        this.updateSelected(group);
      }

      handleToggle(event) {
        const group = event.target;
        if (!group.matches('[data-pg-filter]')) return;
        if (group.open) {
          this.closeFilters(group);
          this.positionOpenPanel();
        } else this.resetDraft(group);
      }

      positionOpenPanel(group = this.querySelector('[data-pg-filter][open]')) {
        if (!group || window.matchMedia('(max-width: 749px)').matches) return;
        const row = this.querySelector('.pg-filter-row').getBoundingClientRect();
        const trigger = group.querySelector('summary').getBoundingClientRect();
        const panel = group.querySelector('.pg-panel');
        const width = Math.min(360, row.width);
        panel.style.setProperty('--pg-panel-left', `${Math.max(0, Math.min(trigger.left - row.left, row.width - width))}px`);
        panel.style.setProperty('--pg-panel-top', `${trigger.bottom - row.top + 8}px`);
        panel.style.setProperty('--pg-panel-height', `${Math.min(460, Math.max(180, window.innerHeight - trigger.bottom - 24))}px`);
        panel.setAttribute('data-pg-positioned', '');
      }

      handleClick(event) {
        if (event.target.closest('[data-pg-query-clear]')) {
          event.preventDefault();
          const input = this.querySelector('[data-pg-query]');
          input.value = '';
          this.syncQueryClear();
          this.closeFilters();
          this.update(this.queryURL(), { focusId: input.id });
          return;
        }
        if (event.target.closest('[data-pg-edit-query]')) {
          event.preventDefault();
          this.querySelector('[data-pg-query]')?.focus();
          return;
        }
        const priceReset = event.target.closest('[data-pg-price-reset]');
        if (priceReset) {
          event.preventDefault();
          const url = new URL(this.pendingPriceURL || window.location.href);
          ['pg_price_min', 'pg_price_max', 'filter.v.price.gte', 'filter.v.price.lte', this.dataset.pageParam || 'page'].forEach(key => url.searchParams.delete(key));
          this.closeFilters();
          this.update(url);
          return;
        }
        if (event.target.closest('[data-pg-price-retry]') && this.pendingPriceURL) {
          this.update(new URL(this.pendingPriceURL));
          return;
        }
        const summary = event.target.closest('[data-pg-filter] > summary');
        if (summary && !summary.parentElement.open) this.positionOpenPanel(summary.parentElement);
        const loadMore = event.target.closest('a[data-pg-load-more]');
        if (loadMore) {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.loadMore(loadMore);
          return;
        }
        const more = event.target.closest('[data-pg-more]');
        if (more) {
          const expanded = this.classList.toggle('pg-expanded');
          more.setAttribute('aria-expanded', String(expanded));
          more.textContent = expanded ? 'Weniger Filter' : more.dataset.moreLabel;
          return;
        }
        const close = event.target.closest('[data-pg-close]');
        if (close) {
          const group = close.closest('[data-pg-filter]');
          group.open = false;
          group.querySelector('summary').focus();
          return;
        }
        const link = event.target.closest('a[data-pg-link]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const url = this.preserveSearchContext(new URL(link.href, window.location.href));
        if (url.origin !== window.location.origin) return;
        event.preventDefault();
        const group = link.closest('[data-pg-filter]');
        const resetPrice = group?.querySelector('[data-pg-context-price]') && link.hasAttribute('data-pg-group-reset');
        for (const key of ['pg_price_min', 'pg_price_max']) {
          url.searchParams.delete(key);
          const value = new URL(this.pendingPriceURL || window.location.href).searchParams.get(key);
          if (!resetPrice && !link.hasAttribute('data-pg-clear') && value !== null) url.searchParams.set(key, value);
        }
        const focusId = group?.querySelector('summary').id;
        this.closeFilters();
        url.searchParams.delete(this.dataset.pageParam || 'page');
        this.update(url, { focusId });
      }

      handleChange(event) {
        if (event.target.matches('[data-pg-sort]')) {
          this.closeFilters();
          this.querySelectorAll('[data-pg-filter]').forEach((group) => this.resetDraft(group));
          this.update(this.formURL(), { focusId: event.target.id });
        } else if (event.target.matches('input[type="checkbox"]')) {
          this.updateSelected(event.target.closest('[data-pg-filter]'));
        }
      }

      updateSelected(group) {
        const label = group?.querySelector('[data-pg-selected]');
        if (label) label.textContent = `${group.querySelectorAll('input[type="checkbox"]:checked').length} ausgewählt`;
      }

      handleInput(event) {
        const input = event.target;
        if (input.matches('[data-pg-query]')) {
          this.syncQueryClear();
          clearTimeout(this.queryTimer);
          // Editing must never be overwritten by an older search response.
          this.cancelLoadMore();
          this.request?.abort();
          this.request = null;
          clearTimeout(this.requestTimeout);
          this.setAttribute('aria-busy', 'false');
          this.querySelector('[data-pg-status]').textContent = '';
          if (!input.value.trim()) {
            this.queryTimer = setTimeout(() => {
              if (!this.isConnected || input.value.trim()) return;
              this.closeFilters();
              this.update(this.queryURL(), { focusId: input.id });
            }, 200);
          }
          return;
        }
        if (input.matches('[data-pg-min], [data-pg-max]')) this.validatePrice(input.closest('[data-pg-price-range]'));
        if (!input.matches('[data-pg-search]')) return;
        const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
        const query = normalize(input.value.trim());
        const group = input.closest('[data-pg-filter]');
        let visible = 0;
        group.querySelectorAll('[data-pg-option]').forEach((option) => {
          option.hidden = !normalize(option.dataset.label).includes(query);
          if (!option.hidden) visible += 1;
        });
        group.querySelector('[data-pg-no-options]').hidden = visible > 0;
      }

      validatePrice(range) {
        const min = range.querySelector('[data-pg-min]');
        const max = range.querySelector('[data-pg-max]');
        max.setCustomValidity(min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value)
          ? 'Der Höchstpreis muss mindestens so hoch wie der Mindestpreis sein.' : '');
      }

      preserveSearchContext(url) {
        if (url.origin !== window.location.origin) return url;
        for (const [key, value] of new URL(window.location.href).searchParams) {
          if (!key.startsWith('filter.') && !['page', this.dataset.pageParam, 'section_id', 'sections', 'pg_price_min', 'pg_price_max'].includes(key) && !url.searchParams.has(key)) url.searchParams.append(key, value);
        }
        url.searchParams.delete('section_id');
        url.searchParams.delete('sections');
        return url;
      }

      formURL() {
        const form = this.querySelector('[data-pg-form]');
        const url = new URL(window.location.href);
        // Preserve locale, preview_theme_id, tracking and other non-filter parameters.
        for (const key of [...url.searchParams.keys()]) {
          if (key.startsWith('filter.') || key === 'pg_price_min' || key === 'pg_price_max' || key === 'sort_by' || key === 'section_id' || key === 'sections' || key === (this.dataset.pageParam || 'page')) url.searchParams.delete(key);
        }
        // Keep active URL filters if filtering has been deliberately hidden in the editor.
        if (!form.querySelector('[data-pg-filter]')) {
          for (const [key, value] of new URL(window.location.href).searchParams) {
            if (key.startsWith('filter.')) url.searchParams.append(key, value);
          }
        }
        for (const [key, value] of new FormData(form)) {
          if (String(value).trim() === '') continue;
          if (key.startsWith('filter.')) url.searchParams.append(key, value);
          else url.searchParams.set(key, value);
        }
        url.hash = '';
        return url;
      }

      queryURL() {
        const form = this.querySelector('[data-pg-query-form]');
        const data = new FormData(form);
        const url = new URL(this.pendingPriceURL || this.renderedURL || window.location.href);
        url.pathname = new URL(form.action, window.location.href).pathname;
        for (const key of ['page', this.dataset.pageParam || 'page', 'section_id', 'sections']) url.searchParams.delete(key);
        for (const key of new Set(data.keys())) {
          if (key.startsWith('filter.') && !url.searchParams.has(key)) {
            for (const value of data.getAll(key)) url.searchParams.append(key, value);
          }
        }
        const query = String(data.get('q') || '').trim();
        url.searchParams.set('q', query || '*');
        url.searchParams.set('type', query ? String(url.searchParams.get('type') || data.get('type') || 'product') : 'product');
        url.searchParams.set('options[prefix]', 'last');
        const sort = this.querySelector('[data-pg-sort]')?.value || url.searchParams.get('sort_by') || data.get('sort_by');
        url.searchParams.set('sort_by', ['title-ascending', 'title-descending', 'price-ascending', 'price-descending'].includes(sort) ? sort : 'title-ascending');
        url.hash = '';
        return url;
      }

      syncQueryClear() {
        const input = this.querySelector('[data-pg-query]');
        const button = this.querySelector('[data-pg-query-clear]');
        if (button) button.hidden = !input?.value.trim();
      }

      submitFilters(event) {
        if (event.target.matches('[data-pg-query-form]')) {
          event.preventDefault();
          const query = event.target.querySelector('[data-pg-query]');
          this.closeFilters();
          this.update(this.queryURL(), { focusId: query.value.trim() ? undefined : query.id });
          return;
        }
        if (!event.target.matches('[data-pg-form]')) return;
        event.preventDefault();
        event.target.querySelectorAll('[data-pg-price-range]').forEach((range) => this.validatePrice(range));
        if (!event.target.reportValidity()) return;
        const url = this.formURL();
        const focusId = event.submitter?.closest('[data-pg-filter]')?.querySelector('summary').id;
        this.closeFilters();
        this.update(url, { focusId });
      }

      priceBounds(url) {
        const cents = key => {
          const text = url.searchParams.get(key);
          if (text === null || !/^\d+(?:[.,]\d{1,2})?$/.test(text)) return null;
          const value = Math.round(Number(text.replace(',', '.')) * 100);
          return Number.isSafeInteger(value) && value >= 0 ? value : null;
        };
        return { min: cents('pg_price_min'), max: cents('pg_price_max') };
      }

      contextPriceURL(input) {
        const url = new URL(input);
        const enabled = Boolean(this.querySelector('[data-pg-context-price]')) || this.dataset.pgPriceEnabled === 'true';
        for (const [key, nativeKey] of [['pg_price_min', 'filter.v.price.gte'], ['pg_price_max', 'filter.v.price.lte']]) {
          if (!enabled) { url.searchParams.delete(key); continue; }
          if (!url.searchParams.has(key) && url.searchParams.has(nativeKey)) url.searchParams.set(key, url.searchParams.get(nativeKey));
          url.searchParams.delete(nativeKey);
        }
        const bounds = this.priceBounds(url);
        if (bounds.min === null) url.searchParams.delete('pg_price_min');
        if (bounds.max === null) url.searchParams.delete('pg_price_max');
        if (bounds.min !== null && bounds.max !== null && bounds.min > bounds.max) {
          url.searchParams.delete('pg_price_min'); url.searchParams.delete('pg_price_max');
        }
        return url;
      }

      hasContextPrice(url) {
        const { min, max } = this.priceBounds(url);
        return (Boolean(this.querySelector('[data-pg-context-price]')) || this.dataset.pgPriceEnabled === 'true') && (min !== null || max !== null);
      }

      syncContextPrice(url) {
        const range = this.querySelector('[data-pg-context-price]');
        if (!range) return;
        const bounds = this.priceBounds(url);
        for (const [name, value] of [['min', bounds.min], ['max', bounds.max]]) {
          const input = range.querySelector(`[data-pg-${name}]`);
          input.disabled = false;
          input.defaultValue = input.value = value === null ? '' : String(value / 100);
        }
        const active = bounds.min !== null || bounds.max !== null;
        const group = range.closest('[data-pg-filter]');
        group.dataset.active = String(active);
        const name = group.querySelector('.pg-filter-name');
        name.querySelector('.pg-badge')?.remove();
        if (active) {
          const badge = document.createElement('span'); badge.className = 'pg-badge'; badge.textContent = '1'; name.append(badge);
        }
        this.querySelector('[data-pg-context-chip]')?.remove();
        let chips = this.querySelector('.pg-active');
        if (chips && !chips.querySelector('.pg-chip')) { chips.remove(); chips = null; }
        if (!active) return;
        if (!chips) {
          chips = document.createElement('div'); chips.className = 'pg-active'; chips.setAttribute('aria-label', 'Aktive Filter');
          const label = document.createElement('span'); label.className = 'pg-active-label'; label.textContent = 'Ihre Auswahl'; chips.append(label);
          const clear = document.createElement('a'); clear.className = 'pg-text-button'; clear.textContent = 'Alle Filter löschen';
          const clearURL = new URL(url);
          for (const key of [...clearURL.searchParams.keys()]) if (key.startsWith('filter.') || key.startsWith('pg_price_') || key === (this.dataset.pageParam || 'page')) clearURL.searchParams.delete(key);
          clear.href = clearURL.href; clear.setAttribute('data-pg-link', ''); clear.setAttribute('data-pg-clear', ''); chips.append(clear);
          this.querySelector('[data-pg-toolbar]').append(chips);
        }
        const chip = document.createElement('a'); chip.className = 'pg-chip'; chip.setAttribute('data-pg-context-chip', ''); chip.setAttribute('data-pg-price-reset', '');
        const resetURL = new URL(url); ['pg_price_min', 'pg_price_max'].forEach(key => resetURL.searchParams.delete(key)); chip.href = resetURL.href;
        const format = value => new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: this.dataset.currency || 'EUR' }).format(value / 100);
        chip.textContent = `Preis: ${bounds.min === null ? 'bis ' + format(bounds.max) : bounds.max === null ? 'ab ' + format(bounds.min) : format(bounds.min) + ' – ' + format(bounds.max)} ×`;
        chip.setAttribute('aria-label', chip.textContent.slice(0, -2) + ' entfernen');
        chips.insertBefore(chip, chips.querySelector('[data-pg-clear]'));
      }

      async updateContextPrice(url, options) {
        this.cancelLoadMore(); this.request?.abort(); clearTimeout(this.requestTimeout);
        const request = new AbortController(); this.request = request;
        this.pendingPriceURL = url.href;
        this.syncContextPrice(url);
        this.setAttribute('aria-busy', 'true');
        this.querySelector('[data-pg-price-error]').hidden = true;
        this.querySelector('[data-pg-status]').textContent = 'Die angezeigten Preise werden geprüft …';
        const bounds = this.priceBounds(url);
        const cards = [], handles = new Set(), pages = new Set();
        let firstContent = null;
        let pageURL = new URL(url);
        pageURL.searchParams.delete(this.dataset.pageParam || 'page');
        pageURL.searchParams.delete('sections');
        try {
          while (pageURL) {
            if (pages.has(pageURL.href)) throw new Error('Repeated search page');
            pages.add(pageURL.href);
            pageURL.searchParams.set('section_id', this.dataset.sectionId);
            this.requestTimeout = setTimeout(() => request.abort(), 20000);
            const response = await fetch(pageURL, { signal: request.signal, credentials: 'same-origin' });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const html = await response.text();
            if (request !== this.request || !this.isConnected) return;
            clearTimeout(this.requestTimeout);
            const root = new DOMParser().parseFromString(html, 'text/html').getElementById(this.id);
            const content = root?.querySelector('[data-pg-content]');
            if (!content || (!content.querySelector('.pg-grid') && !content.querySelector('.pg-empty'))) throw new Error('Search data missing');
            if (!firstContent) firstContent = content;
            for (const card of content.querySelectorAll('.pg-grid > product-card')) {
              const raw = card.getAttribute('data-pg-price');
              if (raw === null || raw.trim() === '' || !Number.isSafeInteger(Number(raw))) throw new Error('Context price missing');
              const handle = card.getAttribute('handle');
              if (!handle) throw new Error('Product handle missing');
              if (!handles.has(handle)) { handles.add(handle); cards.push(card); }
            }
            const next = content.querySelector('[data-pg-load-more]');
            if (!next) { pageURL = null; continue; }
            const nextURL = new URL(next.getAttribute('href'), pageURL);
            if (nextURL.origin !== url.origin || nextURL.pathname !== url.pathname) throw new Error('Unexpected search URL');
            pageURL = new URL(url);
            const nextPage = nextURL.searchParams.get(this.dataset.pageParam || 'page');
            if (!nextPage) throw new Error('Next page missing');
            pageURL.searchParams.set(this.dataset.pageParam || 'page', nextPage);
            pageURL.searchParams.delete('sections');
          }
          if (request !== this.request || !this.isConnected) return;
          // Native facet counts do not include this contextual price constraint.
          firstContent.querySelectorAll('.pg-option-count').forEach(count => { count.hidden = true; });
          const matches = cards.filter(card => {
            const price = Number(card.dataset.pgPrice);
            return (bounds.min === null || price >= bounds.min) && (bounds.max === null || price <= bounds.max);
          });
          const sort = url.searchParams.get('sort_by');
          if (sort === 'price-ascending' || sort === 'price-descending') matches.sort((a, b) => (Number(a.dataset.pgPrice) - Number(b.dataset.pgPrice)) * (sort === 'price-descending' ? -1 : 1));
          const results = firstContent.querySelector('[data-pg-results]');
          const grid = firstContent.querySelector('.pg-grid') || document.createElement('product-list');
          grid.hidden = false; grid.className = 'product-list pg-grid'; grid.id = 'PellegriniSearchProducts-' + this.dataset.sectionId;
          const pageSize = Math.max(1, Number(this.dataset.pageSize) || 24);
          grid.replaceChildren(...matches.slice(0, pageSize));
          results.replaceChildren(grid); results.hidden = false;
          const area = document.createElement('div'); area.className = 'pg-load-more'; area.setAttribute('data-pg-load-more-area', '');
          const more = document.createElement('a'); more.className = 'pg-button'; more.href = url.href; more.textContent = 'Mehr anzeigen'; more.setAttribute('data-pg-load-more', ''); more.setAttribute('aria-controls', grid.id); area.append(more);
          const message = document.createElement('p'); message.className = 'pg-load-more-message'; message.hidden = true; message.setAttribute('data-pg-load-more-message', ''); area.append(message);
          area.hidden = matches.length <= pageSize; results.append(area);
          if (!matches.length) {
            const empty = document.createElement('div'); empty.className = 'pg-empty';
            const heading = document.createElement('h2'); heading.textContent = 'Keine Artikel für diese Suche und Preisauswahl gefunden.'; empty.append(heading);
            const reset = document.createElement('button'); reset.type = 'button'; reset.className = 'pg-button'; reset.textContent = 'Preisfilter zurücksetzen'; reset.setAttribute('data-pg-price-reset', ''); empty.append(reset); results.prepend(empty);
          }
          this.querySelector('[data-pg-content]').replaceWith(firstContent);
          this.contextResults = { cards: matches, shown: Math.min(pageSize, matches.length), pageSize };
          this.finishUpdate(url, options);
        } catch (error) {
          if (request !== this.request || !this.isConnected) return;
          this.querySelector('[data-pg-results]').hidden = true;
          this.querySelector('[data-pg-price-error]').hidden = false;
          this.querySelector('[data-pg-status]').textContent = 'Die Preisprüfung ist fehlgeschlagen. Bitte erneut versuchen.';
        } finally {
          if (request === this.request) { clearTimeout(this.requestTimeout); this.setAttribute('aria-busy', 'false'); }
        }
      }

      appendContextProducts(button) {
        const state = this.contextResults;
        const cards = state.cards.slice(state.shown, state.shown + state.pageSize);
        this.querySelector('.pg-grid').append(...cards); state.shown += cards.length;
        if (state.shown >= state.cards.length) {
          button.hidden = true;
          const message = this.querySelector('[data-pg-load-more-message]'); message.textContent = 'Alle Treffer dieser Auswahl sind geladen.'; message.hidden = false;
        }
        this.querySelector('[data-pg-status]').textContent = 'Weitere passende Artikel geladen.';
        if (document.activeElement === button) cards[0]?.querySelector('a[href]')?.focus({ preventScroll: true });
        this.dispatchEvent(new CustomEvent('pellegrini:search:updated', { bubbles: true }));
      }

      prepareLoadMore() {
        this.querySelector('[data-pg-load-more]')?.setAttribute('role', 'button');
      }

      cancelLoadMore() {
        this.moreRequest?.abort();
        this.moreRequest = null;
        clearTimeout(this.moreTimeout);
        const button = this.querySelector('[data-pg-load-more]');
        if (button) {
          button.removeAttribute('aria-disabled');
          button.textContent = 'Mehr anzeigen';
        }
        this.querySelector('.pg-grid')?.removeAttribute('aria-busy');
      }

      async loadMore(button) {
        if (this.moreRequest || this.getAttribute('aria-busy') === 'true') return;
        if (this.contextResults) { this.appendContextProducts(button); return; }
        const grid = this.querySelector('.pg-grid');
        const contentGrid = this.querySelector('.pg-content-grid');
        const area = this.querySelector('[data-pg-load-more-area]');
        if (!grid || !contentGrid || !area) return;
        // Keep the current filters, market, locale and preview parameters.
        const pageParam = this.dataset.pageParam || 'page';
        const url = new URL(this.renderedURL || window.location.href);
        const nextPage = new URL(button.href, url).searchParams.get(pageParam);
        if (!nextPage) return;
        url.searchParams.set(pageParam, nextPage);
        url.searchParams.delete('sections');
        url.searchParams.set('section_id', this.dataset.sectionId);
        const request = new AbortController();
        this.moreRequest = request;
        const status = this.querySelector('[data-pg-status]');
        const message = area.querySelector('[data-pg-load-more-message]');
        message.hidden = true;
        button.setAttribute('aria-disabled', 'true');
        button.textContent = 'Wird geladen …';
        grid.setAttribute('aria-busy', 'true');
        status.textContent = 'Weitere Treffer werden geladen.';
        this.moreTimeout = setTimeout(() => request.abort(), 15000);
        try {
          const response = await fetch(url.toString(), { signal: request.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const html = await response.text();
          if (request !== this.moreRequest || !this.isConnected) return;
          const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(this.id);
          const freshGrid = fresh?.querySelector('.pg-grid');
          const freshArea = fresh?.querySelector('[data-pg-load-more-area]');
          const freshContentGrid = fresh?.querySelector('.pg-content-grid');
          if (!freshGrid || !freshContentGrid || !freshArea || freshArea.dataset.pgPage !== nextPage || (!freshGrid.children.length && !freshContentGrid.children.length)) {
            throw new Error('Next search page missing');
          }
          const knownHandles = new Set(Array.from(grid.children, card => card.getAttribute('handle')));
          const knownContent = new Set(Array.from(contentGrid.children, card => card.dataset.pgResultKey));
          const cards = Array.from(freshGrid.children).filter(card => !knownHandles.has(card.getAttribute('handle')));
          const contentCards = Array.from(freshContentGrid.children).filter(card => !knownContent.has(card.dataset.pgResultKey));
          const hadFocus = document.activeElement === button;
          grid.append(...cards);
          contentGrid.append(...contentCards);
          grid.hidden = !grid.children.length;
          contentGrid.closest('.pg-content-results').hidden = !contentGrid.children.length;
          const next = freshArea.querySelector('[data-pg-load-more]');
          area.dataset.pgPage = freshArea.dataset.pgPage;
          if (next) button.href = next.getAttribute('href');
          else {
            button.hidden = true;
            message.textContent = 'Alle Treffer dieser Auswahl sind geladen.';
            message.hidden = false;
          }
          status.textContent = next ? 'Weitere Treffer geladen.' : 'Alle Treffer dieser Auswahl sind geladen.';
          // Continue keyboard navigation at the newly appended products without scrolling.
          if (hadFocus && (cards.length || contentCards.length)) {
            const firstCard = cards[0] || contentCards[0];
            const focusTarget = firstCard.querySelector('a[href]') || firstCard;
            if (!focusTarget.matches('a[href]')) focusTarget.setAttribute('tabindex', '-1');
            focusTarget.focus({ preventScroll: true });
          }
          this.dispatchEvent(new CustomEvent('pellegrini:search:updated', { bubbles: true }));
        } catch (error) {
          if (request !== this.moreRequest || !this.isConnected) return;
          message.textContent = 'Die weiteren Treffer konnten nicht geladen werden. Bitte erneut versuchen.';
          message.hidden = false;
          status.textContent = message.textContent;
        } finally {
          if (request === this.moreRequest) this.cancelLoadMore();
        }
      }

      async update(url, { history = true, focusId, scroll = false, replace = false } = {}) {
        clearTimeout(this.queryTimer);
        url = new URL(url);
        if (!url.searchParams.get('q')?.trim()) {
          url.searchParams.delete(this.dataset.pageParam || 'page');
          url.searchParams.set('q', '*');
          url.searchParams.set('type', 'product');
        }
        url = this.contextPriceURL(url);
        const options = { history, focusId, scroll, replace };
        if (this.hasContextPrice(url)) {
          url.searchParams.delete(this.dataset.pageParam || 'page');
          return this.updateContextPrice(url, options);
        }
        this.cancelLoadMore();
        this.request?.abort();
        clearTimeout(this.requestTimeout);
        const request = new AbortController();
        this.request = request;
        const requestURL = new URL(url);
        requestURL.searchParams.set('section_id', this.dataset.sectionId);
        this.setAttribute('aria-busy', 'true');
        const status = this.querySelector('[data-pg-status]');
        status.textContent = 'Die Suche wird aktualisiert.';
        let timedOut = false;
        this.requestTimeout = setTimeout(() => { timedOut = true; request.abort(); }, 15000);
        try {
          const response = await fetch(requestURL.toString(), { signal: request.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const html = await response.text();
          if (request !== this.request || !this.isConnected) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.getElementById(this.id)?.querySelector('[data-pg-content]');
          if (!fresh) throw new Error('Search section missing');
          this.querySelector('[data-pg-content]').replaceWith(fresh);
          this.contextResults = null;
          this.finishUpdate(url, options);
        } catch (error) {
          if (request !== this.request || !this.isConnected) return;
          if (error.name === 'AbortError' && !timedOut) return;
          // Normal Shopify navigation remains the reliable fallback.
          window.location.assign(url.toString());
        } finally {
          if (request === this.request) {
            clearTimeout(this.requestTimeout);
            this.setAttribute('aria-busy', 'false');
          }
        }
      }

      finishUpdate(url, { history = true, focusId, scroll = false, replace = false } = {}) {
        this.pendingPriceURL = null;
        this.renderedURL = url.href;
        this.orderFilterGroups(); this.prepareLoadMore(); this.syncContextPrice(url); this.syncQueryClear();
        const more = this.querySelector('[data-pg-more]');
        if (more && this.classList.contains('pg-expanded')) { more.setAttribute('aria-expanded', 'true'); more.textContent = 'Weniger Filter'; }
        if (history && url.href !== window.location.href) window.history[replace ? 'replaceState' : 'pushState']({ ...window.history.state, pellegrini: true }, '', url);
        this.setAttribute('aria-busy', 'false');
        const results = this.querySelector('[data-pg-results]');
        this.querySelector('[data-pg-status]').textContent = url.searchParams.get('q') === '*' ? 'Artikelübersicht aktualisiert.' : 'Suchergebnisse aktualisiert.';
        const focusTarget = focusId ? this.querySelector(`#${CSS.escape(focusId)}`) : results;
        (focusTarget || results)?.focus({ preventScroll: true });
        if (scroll) {
          const toolbar = this.querySelector('[data-pg-toolbar]');
          const sticky = getComputedStyle(toolbar).position === 'sticky';
          const offset = sticky ? toolbar.offsetHeight + parseFloat(getComputedStyle(this).getPropertyValue('--pg-sticky-offset')) + 16 : 16;
          window.scrollTo({ top: Math.max(0, window.scrollY + results.getBoundingClientRect().top - offset), behavior: 'instant' });
        }
        this.dispatchEvent(new CustomEvent('pellegrini:search:updated', { bubbles: true }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pellegrini-team-plz"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('pellegrini-team-finder')) return;
  const bounds = value => [Number(value.padEnd(5, '0')), Number(value.padEnd(5, '9'))];
  function compileRules(text) {
    const include = [], exclude = [], invalid = [];
    const tokens = text.trim().replace(/[–—]/g, '-').replace(/\s*-\s*/g, '-').split(/[,;\s]+/).filter(Boolean);
    for (const token of tokens) {
      const match = /^(!?)(\d{1,5})(?:-(\d{1,5}))?$/.exec(token);
      if (!match || (match[3] && (match[2].length !== match[3].length || Number(match[2]) > Number(match[3])))) {
        invalid.push(token); continue;
      }
      const interval = [bounds(match[2])[0], bounds(match[3] || match[2])[1]];
      (match[1] ? exclude : include).push(interval);
    }
    let intervals = include;
    for (const [low, high] of exclude) {
      intervals = intervals.flatMap(([start, end]) => {
        if (high < start || low > end) return [[start, end]];
        return [...(start < low ? [[start, low - 1]] : []), ...(end > high ? [[high + 1, end]] : [])];
      });
    }
    if (exclude.length && !include.length) invalid.push('Ausschluss ohne zugeordneten Bereich');
    return { intervals, invalid, configured: include.length > 0 };
  }
  class PellegriniTeamFinder extends HTMLElement {
    connectedCallback() { this._frame = requestAnimationFrame(() => this.initialize()); }
    disconnectedCallback() { cancelAnimationFrame(this._frame); clearTimeout(this._timer); this._events?.abort(); }
    initialize() {
      this._events?.abort();
      this._events = new AbortController();
      const options = { signal: this._events.signal };
      this._panels = [...this.querySelectorAll('[data-map-panel]')];
      this._status = this.querySelector('[data-map-status]');
      this._input = this.querySelector('[data-postcode-input]');
      this._empty = this.querySelector('[data-empty]');
      if (!this._panels.length) return;
      this._rules = new Map(this._panels.map(p => [p.dataset.mapPanel, compileRules(p.dataset.postcodes || '')]));
      this._hasRules = [...this._rules.values()].some(r => r.configured);
      this._invalidRules = [...this._rules.values()].some(r => r.invalid.length);
      this.prepareMap();
      this._triggers = [...this.querySelectorAll('[data-map-select]')];
      const note = this.querySelector('[data-config-note]');
      const missing = this._panels.filter(p => !this._rules.get(p.dataset.mapPanel).configured);
      const invalid = this._panels.filter(p => this._rules.get(p.dataset.mapPanel).invalid.length);
      if (note && (missing.length || invalid.length)) {
        note.hidden = false;
        note.textContent = [
          missing.length ? 'PLZ-Zuordnung fehlt: ' + missing.map(p => this.title(p)).join(', ') + '.' : '',
          invalid.length ? 'Ungültige PLZ-Regeln: ' + invalid.map(p => this.title(p)).join(', ') + '. Bitte die Einträge prüfen.' : ''
        ].filter(Boolean).join(' ');
      }
      const keys = new Set(this._panels.map(p => p.dataset.mapPanel));
      this._triggers.forEach(trigger => {
        if (!keys.has(trigger.dataset.mapSelect)) {
          trigger.setAttribute('aria-disabled', 'true'); trigger.removeAttribute('href');
          if (trigger.classList.contains('p-team__map-label')) trigger.hidden = true;
        }
      });
      this.classList.add('is-ready');
      this.querySelector('[data-finder-controls]').hidden = false;
      this.resetSelection();
      this.addEventListener('click', event => {
        const area = event.target.closest('[data-postcode-map]');
        if (area && this.contains(area)) {
          event.preventDefault();
          const postcode = area.dataset.postcodeMap;
          if (this._selectedPostcode === postcode) { this.showAll(); return; }
          this.clearInput();
          const keys = this._mapAssignments.get(postcode) || [];
          this.display(keys, keys.length ? 'PLZ-Gebiet ' + postcode + (keys.length > 1 ? '. Bitte PLZ genauer eingeben.' : '') : 'Für dieses PLZ-Gebiet ist noch kein Team hinterlegt.', postcode);
          if (keys.length && window.matchMedia('(max-width: 1049px)').matches) this._panels.find(p => p.dataset.mapPanel === keys[0]).scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
          return;
        }
        const trigger = event.target.closest('[data-map-select]');
        if (trigger && this.contains(trigger)) {
          event.preventDefault();
          if (trigger.getAttribute('aria-disabled') !== 'true') this.select(trigger.dataset.mapSelect, true);
          return;
        }
        if (event.target.closest('[data-show-all]')) { this.showAll(); return; }
        const reference = event.target.closest('a[href^="#PellegriniName-"]');
        if (reference) {
          const target = document.getElementById(reference.getAttribute('href').slice(1));
          const panel = target?.closest('[data-map-panel]');
          if (panel && this.contains(panel)) {
            event.preventDefault(); this.select(panel.dataset.mapPanel, false);
            target.setAttribute('tabindex','-1'); target.focus({preventScroll:true});
            target.scrollIntoView({block:'center',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
          }
        }
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === ' ' && event.target.matches('.p-team__map-label')) { event.preventDefault(); event.target.click(); }
        if (event.key === 'Escape' && event.target === this._input) { this.resetSelection(); }
        if (event.target.matches('[data-postcode-map]')) {
          if (event.key === ' ') { event.preventDefault(); event.target.dispatchEvent(new MouseEvent('click', {bubbles:true,cancelable:true})); }
          const direction = ['ArrowRight','ArrowDown'].includes(event.key) ? 1 : ['ArrowLeft','ArrowUp'].includes(event.key) ? -1 : 0;
          if (direction) {
            event.preventDefault(); const index = this._mapLinks.indexOf(event.target);
            const next = this._mapLinks[(index + direction + this._mapLinks.length) % this._mapLinks.length];
            this._mapLinks.forEach(link => link.setAttribute('tabindex', link === next ? '0' : '-1')); next.focus();
          }
        }
      }, options);
      this._input.addEventListener('input', () => {
        clearTimeout(this._timer);
        this._selectedPostcode = null;
        if (!this._input.value.trim()) { this.showAll(); return; }
        this._timer = setTimeout(() => this.search(), 150);
      }, options);
      this.querySelector('[data-postcode-form]').addEventListener('submit', event => {
        event.preventDefault(); clearTimeout(this._timer); this.search();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        let panel = event.target.closest?.('[data-map-panel]');
        if (!panel && event.detail?.blockId) {
          const block = [...this.querySelectorAll('[data-shopify-editor-block]')].find(el => {
            try { return JSON.parse(el.getAttribute('data-shopify-editor-block')).id === event.detail.blockId; } catch { return false; }
          });
          panel = block?.closest('[data-map-panel]');
        }
        if (panel && this.contains(panel)) this.select(panel.dataset.mapPanel, false);
      }, options);
      window.addEventListener('hashchange', () => this.showHashTarget(), options);
      this.showHashTarget();
    }
    title(panel) { return panel.querySelector('.p-team__pair-heading')?.textContent.trim() || 'Vertriebsteam'; }
    matches(query) {
      const [low, high] = bounds(query);
      return this._panels.filter(p => this._rules.get(p.dataset.mapPanel).intervals.some(([start, end]) => start <= high && end >= low));
    }
    prepareMap() {
      const NS = 'http://www.w3.org/2000/svg';
      const defs = this.querySelector('[data-map-patterns]');
      defs.replaceChildren();
      this._mapLinks = [...this.querySelectorAll('[data-postcode-map]')];
      this._mapLabels = new Map([...this.querySelectorAll('[data-postcode-label]')].map(label => [label.dataset.postcodeLabel, label]));
      this._mapAssignments = new Map();
      this._mapLinks.forEach(link => {
        const prefix = link.dataset.postcodeMap;
        const panels = this._invalidRules ? [] : this.matches(prefix);
        const colors = panels.map(p => getComputedStyle(p).getPropertyValue('--p-map-color').trim() || '#681230');
        this._mapAssignments.set(prefix, panels.map(p => p.dataset.mapPanel));
        let fill = colors[0] || '#DCDAD5';
        if (colors.length > 1) {
          const pattern = document.createElementNS(NS,'pattern');
          const id = this.closest('.p-team').id + '-stripe-' + prefix;
          pattern.setAttribute('id', id); pattern.setAttribute('patternUnits','userSpaceOnUse');
          pattern.setAttribute('width',String(colors.length * 5)); pattern.setAttribute('height','12'); pattern.setAttribute('patternTransform','rotate(45)');
          colors.forEach((color,i) => {const rect=document.createElementNS(NS,'rect');rect.setAttribute('x',String(i*5));rect.setAttribute('width','5');rect.setAttribute('height','12');rect.setAttribute('fill',color);pattern.append(rect);});
          defs.append(pattern); fill='url(#'+id+')';
        }
        link.querySelector('path').style.fill = fill;
        link.setAttribute('aria-label', 'PLZ-Gebiet ' + prefix + (panels.length ? ': '+panels.map(p=>this.title(p)).join(', ') : ': noch keine Zuordnung'));
      });
      const legend = this.querySelector('[data-map-legend]');
      legend.replaceChildren(); legend.hidden = false;
      this._panels.forEach(panel => {
        const button=document.createElement('button'); button.type='button'; button.className='p-team__legend-button';
        button.dataset.mapSelect=panel.dataset.mapPanel; button.setAttribute('aria-controls',panel.id);
        button.style.setProperty('--p-map-color',getComputedStyle(panel).getPropertyValue('--p-map-color'));
        button.textContent=this.title(panel); legend.append(button);
      });
    }
    showHashTarget() {
      let id;
      try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
      const panel = document.getElementById(id)?.closest('[data-map-panel]');
      if (panel && this.contains(panel)) this.select(panel.dataset.mapPanel, false);
    }
    display(keys, message, postcode = null) {
      this._selectedPostcode = postcode;
      this.dataset.selectionState = 'selected';
      const selected = new Set(keys);
      this._panels.forEach(panel => { panel.hidden = !selected.has(panel.dataset.mapPanel); });
      this._triggers.forEach(trigger => trigger.setAttribute('aria-current', String(selected.has(trigger.dataset.mapSelect))));
      this._mapLinks.forEach(link => {
        const active = (this._mapAssignments.get(link.dataset.postcodeMap) || []).some(key => selected.has(key));
        link.setAttribute('aria-current', String(active));
        this._mapLabels.get(link.dataset.postcodeMap)?.setAttribute('data-active', String(active));
      });
      this._empty.hidden = keys.length > 0;
      this._status.textContent = message;
      this.dataset.selectedTeam = keys.join(' ');
    }
    clearInput() { clearTimeout(this._timer); this._input.value = ''; this._input.removeAttribute('aria-invalid'); }
    resetSelection() { this.showAll(); }
    select(key, scroll) {
      const selected = this._panels.find(panel => panel.dataset.mapPanel === key);
      if (!selected) return;
      this.clearInput();
      this.display([key], this.title(selected));
      if (scroll && window.matchMedia('(max-width: 1049px)').matches) {
        selected.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    }
    showAll() {
      this.clearInput();
      this.display(this._panels.map(p => p.dataset.mapPanel), 'Alle Vertriebsteams');
      this.dataset.selectionState = 'neutral';
      this._triggers.forEach(trigger => trigger.setAttribute('aria-current', 'false'));
      this._mapLinks.forEach(link => link.setAttribute('aria-current', 'false'));
      this._mapLabels.forEach(label => label.setAttribute('data-active', 'false'));
    }
    search() {
      const query = this._input.value.trim();
      this._input.removeAttribute('aria-invalid');
      if (!query) { this.resetSelection(); return; }
      if (!/^\d{1,5}$/.test(query)) {
        this._input.setAttribute('aria-invalid', 'true');
        this.display([], 'Bitte geben Sie eine bis fünf Ziffern ein.'); this._empty.hidden = true; return;
      }
      if (!this._hasRules || this._invalidRules) {
        this.display([], 'Die PLZ-Suche ist noch nicht eingerichtet. Bitte wählen Sie Ihr Gebiet auf der Karte.');
        this._empty.hidden = true; return;
      }
      const matches = this.matches(query);
      const label = query.length < 5 ? 'PLZ beginnend mit ' + query : 'PLZ ' + query;
      const message = matches.length ? label + (matches.length > 1 && query.length < 5 ? '. Weitere Ziffern grenzen die Auswahl ein.' : '') : 'Keine Zuordnung für ' + label + '.';
      this.display(matches.map(p => p.dataset.mapPanel), message);
    }
  }
  customElements.define('pellegrini-team-finder', PellegriniTeamFinder);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pellegrini-weingueter"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pellegrini-winery-index')) {
    customElements.define('pellegrini-winery-index', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          window.addEventListener('popstate', this.handleHistoryChange);
          this.handleHistoryChange();
          return;
        }
        if (this.querySelector('[data-empty]')) {
          this.initialize();
          return;
        }
        this.readyObserver?.disconnect();
        this.readyObserver = new MutationObserver(() => {
          if (!this.querySelector('[data-empty]')) return;
          this.readyObserver.disconnect();
          this.initialize();
        });
        this.readyObserver.observe(this, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.readyObserver?.disconnect();
        if (this.handleHistoryChange) window.removeEventListener('popstate', this.handleHistoryChange);
      }

      initialize() {
        if (!this.isConnected) return;
        if (this.initialized) return;
        this.initialized = true;
        const normalise = (value) => String(value || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss').replace(/\s+/g, ' ');
        const readList = (raw) => {
          try {
            const value = JSON.parse(raw || 'null');
            return (Array.isArray(value) ? value : [value]).filter((item) => typeof item === 'string' && item.trim()).map((item) => item.trim());
          } catch { return []; }
        };
        const collator = new Intl.Collator(document.documentElement.lang || 'de', { sensitivity: 'base', numeric: true });
        this.normalise = normalise;
        this.countryKey = (value) => {
          const key = normalise(value).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
          if (key === 'oesterreich') return 'osterreich';
          if (key === 'suedafrika') return 'sudafrika';
          return key;
        };
        this.fixedCountry = this.countryKey(this.dataset.fixedCountry);
        const otherCountryLabels = (this.dataset.otherCountries || '').split(/[\n,;]+/).map((value) => value.trim()).filter(Boolean);
        this.otherCountries = new Set(otherCountryLabels.map(this.countryKey).filter(Boolean));
        this.countryLabels = new Map(otherCountryLabels.map((label) => [this.countryKey(label), label]));
        this.cards = [...this.querySelectorAll('[data-card]')].map((element) => ({
          element,
          name: normalise(element.dataset.name),
          region: normalise(element.dataset.region),
          country: this.countryKey(element.dataset.country),
          countryLabel: element.dataset.country,
          wineTypes: readList(element.dataset.wineTypes),
          grapes: readList(element.dataset.grapes),
          alcoholFree: element.dataset.alcoholFree === 'true'
        }));
        if (this.dataset.manualOrder !== 'true') {
          this.cards.sort((a, b) => collator.compare(a.element.dataset.name, b.element.dataset.name));
        }
        const grid = this.querySelector('[data-grid]');
        this.cards.forEach((card) => grid.append(card.element));
        this.search = this.querySelector('[data-search]');
        this.wineType = this.querySelector('[data-wine-type]');
        this.grape = this.querySelector('[data-grape]');
        this.alcoholFree = this.querySelector('[data-alcohol-free-filter]');
        this.countries = this.querySelector('[data-countries]');
        this.readCountryFromUrl();

        const uniqueValues = (values) => {
          const unique = new Map();
          values.forEach((label) => { if (normalise(label) && !unique.has(normalise(label))) unique.set(normalise(label), label); });
          return [...unique.entries()].sort((a, b) => collator.compare(a[1], b[1]));
        };
        const addedCountries = new Set();
        uniqueValues(this.cards.map((card) => card.countryLabel)).forEach(([, label]) => {
          const key = this.countryKey(label);
          if (!key || addedCountries.has(key)) return;
          addedCountries.add(key);
          this.countryLabels.set(key, label);
          this.addCountryButton(key, label);
        });
        const fillSelect = (select, property, fieldSelector) => {
          if (!select) return false;
          const values = uniqueValues(this.cards.flatMap((card) => card[property]));
          values.forEach(([key, label]) => select.add(new Option(label, key)));
          this.querySelector(fieldSelector).hidden = values.length === 0;
          return values.length > 0;
        };
        const hasWineTypes = fillSelect(this.wineType, 'wineTypes', '[data-wine-type-field]');
        const hasGrapes = fillSelect(this.grape, 'grapes', '[data-grape-field]');
        const hasAlcoholFree = Boolean(this.alcoholFree) && this.cards.some((card) => card.alcoholFree);
        if (this.alcoholFree) this.querySelector('[data-alcohol-free-field]').hidden = !hasAlcoholFree;
        this.hasFields = hasWineTypes || hasGrapes || hasAlcoholFree;
        this.querySelector('[data-fields]').hidden = !this.hasFields;
        const help = this.querySelector('[data-filter-help]');
        if (help) help.hidden = !hasWineTypes && !hasGrapes && !hasAlcoholFree;

        const editorNote = this.querySelector('[data-editor-note]');
        if (editorNote) {
          const missing = [];
          if (this.wineType && !hasWineTypes) missing.push('Weinartenfilter: Im Feld „weinarten“ (Liste einzeiliger Texte) sind noch keine auswertbaren Werte hinterlegt.');
          if (this.grape && !hasGrapes) missing.push('Rebsortenfilter: Im Feld „rebsorten“ (Liste einzeiliger Texte) sind noch keine auswertbaren Werte hinterlegt.');
          if (this.alcoholFree && !hasAlcoholFree) missing.push('Alkoholfrei-Filter: Bei keinem angezeigten Weingut ist „alkoholfrei_im_sortiment“ (Wahr/Falsch) auf Ja gesetzt.');
          const list = editorNote.querySelector('[data-editor-missing-fields]');
          missing.forEach((text) => {
            const item = document.createElement('li');
            item.textContent = text;
            list.append(item);
          });
          editorNote.hidden = missing.length === 0;
        }

        this.addEventListener('click', (event) => {
          const countryButton = event.target.closest('[data-country-filter]');
          if (countryButton && this.contains(countryButton) && !this.fixedCountry) {
            this.country = countryButton.dataset.countryFilter;
            this.update();
            this.writeCountryToUrl();
          }
        });
        this.addEventListener('input', (event) => { if (event.target === this.search) this.update(); });
        this.addEventListener('change', (event) => {
          if ([this.wineType, this.grape, this.alcoholFree].includes(event.target)) this.update();
        });
        this.handleHistoryChange = () => {
          this.readCountryFromUrl();
          this.update();
        };
        window.addEventListener('popstate', this.handleHistoryChange);
        this.update();
      }

      readCountryFromUrl() {
        if (this.fixedCountry) {
          this.country = this.fixedCountry;
          return;
        }
        const value = new URLSearchParams(window.location.search).get('land') || '';
        const key = value.length <= 80 ? this.countryKey(value) : '';
        this.country = key === 'alle' || key === 'all' ? '' : key;
      }

      writeCountryToUrl() {
        if (this.fixedCountry) return;
        if (!/^https?:$/.test(window.location.protocol)) return;
        const url = new URL(window.location.href);
        if (this.country) url.searchParams.set('land', this.country);
        else url.searchParams.delete('land');
        if (url.href === window.location.href) return;
        try {
          window.history.replaceState(window.history.state, '', url.href);
        } catch {
          // Die Filter bleiben auch in Vorschauen ohne History-Zugriff nutzbar.
        }
      }

      addCountryButton(key, label, fromLink = false) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'spg-wineries__country';
        button.dataset.countryFilter = key;
        if (fromLink) button.dataset.linkCountry = '';
        button.textContent = label;
        button.setAttribute('aria-pressed', 'false');
        button.setAttribute('aria-controls', this.querySelector('[data-grid]').id);
        this.countries.append(button);
      }

      updateCountryHeading() {
        const heading = this.querySelector('[data-country-heading]');
        if (!heading) return;
        const template = heading.dataset.headingTemplate || '';
        const allHeading = heading.dataset.headingAll || 'Unsere Weingüter';
        let countryLabel = '';
        if (this.fixedCountry) {
          countryLabel = (this.dataset.fixedCountry || '').trim();
        } else if (this.country === 'sonstige') {
          countryLabel = 'weiteren Ländern';
        } else if (this.country) {
          countryLabel = this.countryLabels.get(this.country)
            || this.countries.querySelector('[data-country-filter][aria-pressed="true"]')?.textContent.trim()
            || '';
        }
        heading.textContent = countryLabel ? template.split('[Land]').join(countryLabel) : allHeading;
      }

      updateCountryControls() {
        if (this.fixedCountry) {
          this.countries.hidden = true;
          this.querySelector('[data-toolbar]').hidden = !this.search;
          this.querySelector('[data-controls]').hidden = this.cards.length === 0 || (!this.search && !this.hasFields);
          return;
        }
        const linkedButton = this.countries.querySelector('[data-link-country]');
        if (linkedButton && linkedButton.dataset.countryFilter !== this.country) linkedButton.remove();
        const buttons = [...this.countries.querySelectorAll('[data-country-filter]')];
        if (this.country && !buttons.some((button) => button.dataset.countryFilter === this.country)) {
          const fallback = this.country.replace(/-/g, ' ');
          const label = this.country === 'sonstige' ? 'Sonstige' : this.countryLabels.get(this.country) || fallback.charAt(0).toUpperCase() + fallback.slice(1);
          this.addCountryButton(this.country, label, true);
        }
        this.countries.hidden = this.countries.dataset.enabled !== 'true' && !this.country;
        const hasToolbar = !this.countries.hidden || Boolean(this.search);
        this.querySelector('[data-toolbar]').hidden = !hasToolbar;
        this.querySelector('[data-controls]').hidden = this.cards.length === 0 || (!hasToolbar && !this.hasFields);
        this.countries.querySelectorAll('[data-country-filter]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.countryFilter === this.country));
        });
        if (this.lastScrolledCountry !== this.country) {
          this.lastScrolledCountry = this.country;
          requestAnimationFrame(() => {
            if (!this.isConnected || this.countries.hidden) return;
            const active = this.countries.querySelector('[aria-pressed="true"]');
            if (!active || this.countries.scrollWidth <= this.countries.clientWidth) return;
            const listRect = this.countries.getBoundingClientRect();
            const buttonRect = active.getBoundingClientRect();
            this.countries.scrollLeft += buttonRect.left - listRect.left - (listRect.width - buttonRect.width) / 2;
          });
        }
      }

      update() {
        const query = this.normalise(this.search?.value);
        const wineType = this.wineType?.value || '';
        const grape = this.grape?.value || '';
        const alcoholFree = Boolean(this.alcoholFree?.checked);
        let visible = 0;
        this.cards.forEach((card) => {
          const countryMatch = !this.country || (this.country === 'sonstige' ? this.otherCountries.has(card.country) : card.country === this.country);
          const match = countryMatch
            && (!query || card.name.includes(query) || card.region.includes(query))
            && (!wineType || card.wineTypes.some((value) => this.normalise(value) === wineType))
            && (!grape || card.grapes.some((value) => this.normalise(value) === grape))
            && (!alcoholFree || card.alcoholFree);
          card.element.hidden = !match;
          if (match) visible += 1;
        });
        this.updateCountryControls();
        this.updateCountryHeading();
        this.querySelector('[data-empty]').hidden = visible > 0;
        const pageSuffix = Number(this.dataset.pageCount) > 1 ? ' auf dieser Seite' : '';
        this.querySelector('[data-status]').textContent = `${visible} von ${this.cards.length} Weingütern${pageSuffix}`;
      }

    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pellegrini-weingutkarte-frankreich"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pellegrini-winery-map-fr')) {
    customElements.define('pellegrini-winery-map-fr', class extends HTMLElement {
      connectedCallback() {
        if (!window.Shopify?.designMode || this.mapEditorReady) return;
        this.mapEditorReady = true;
        this.onMapBlockSelect = (event) => {
          const id = String(event.detail?.blockId || '');
          this.querySelectorAll('[data-map-block]').forEach((area) => {
            area.classList.toggle('is-selected', area.dataset.mapBlock === id);
          });
        };
        this.onMapBlockDeselect = () => {
          this.querySelectorAll('.is-selected').forEach((area) => area.classList.remove('is-selected'));
        };
        this.addEventListener('shopify:block:select', this.onMapBlockSelect);
        this.addEventListener('shopify:block:deselect', this.onMapBlockDeselect);
      }
      disconnectedCallback() {
        this.removeEventListener('shopify:block:select', this.onMapBlockSelect);
        this.removeEventListener('shopify:block:deselect', this.onMapBlockDeselect);
        this.mapEditorReady = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pellegrini-weingutkarte-spanien"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pellegrini-winery-map-es')) {
    customElements.define('pellegrini-winery-map-es', class extends HTMLElement {
      connectedCallback() {
        if (!window.Shopify?.designMode || this.mapEditorReady) return;
        this.mapEditorReady = true;
        this.onMapBlockSelect = (event) => {
          const id = String(event.detail?.blockId || '');
          this.querySelectorAll('[data-map-block]').forEach((area) => {
            area.classList.toggle('is-selected', area.dataset.mapBlock === id);
          });
        };
        this.onMapBlockDeselect = () => {
          this.querySelectorAll('.is-selected').forEach((area) => area.classList.remove('is-selected'));
        };
        this.addEventListener('shopify:block:select', this.onMapBlockSelect);
        this.addEventListener('shopify:block:deselect', this.onMapBlockDeselect);
      }
      disconnectedCallback() {
        this.removeEventListener('shopify:block:select', this.onMapBlockSelect);
        this.removeEventListener('shopify:block:deselect', this.onMapBlockDeselect);
        this.mapEditorReady = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pellegrini-weingutkarte"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pellegrini-winery-map')) {
    customElements.define('pellegrini-winery-map', class extends HTMLElement {
      connectedCallback() {
        if (!window.Shopify?.designMode || this.mapEditorReady) return;
        this.mapEditorReady = true;
        this.onMapBlockSelect = (event) => {
          const id = String(event.detail?.blockId || '');
          this.querySelectorAll('[data-map-block]').forEach((area) => {
            area.classList.toggle('is-selected', area.dataset.mapBlock === id);
          });
        };
        this.onMapBlockDeselect = () => {
          this.querySelectorAll('.is-selected').forEach((area) => area.classList.remove('is-selected'));
        };
        this.addEventListener('shopify:block:select', this.onMapBlockSelect);
        this.addEventListener('shopify:block:deselect', this.onMapBlockDeselect);
      }
      disconnectedCallback() {
        this.removeEventListener('shopify:block:select', this.onMapBlockSelect);
        this.removeEventListener('shopify:block:deselect', this.onMapBlockDeselect);
        this.mapEditorReady = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pellegrini-weingutprofil"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pw-winery-video')) {
    class PellegriniWineryVideo extends HTMLElement {
      static parseVideoUrl(raw) {
        let url;
        try {
          url = new URL(raw);
        } catch {
          return null;
        }
        if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password || url.port) return null;

        const result = { external: url.href, provider: '', embed: '', privacy: '' };
        const host = url.hostname.toLowerCase();
        const parts = url.pathname.split('/').filter(Boolean);
        const youtubeHosts = ['youtube.com', 'www.youtube.com', 'm.youtube.com', 'music.youtube.com',
          'youtube-nocookie.com', 'www.youtube-nocookie.com'];
        let id = '';
        if (host === 'youtu.be' || host === 'www.youtu.be') {
          id = parts.length === 1 ? parts[0] : '';
        } else if (youtubeHosts.includes(host)) {
          if (url.pathname === '/watch') id = url.searchParams.get('v') || '';
          else if (['embed', 'shorts', 'live', 'v'].includes(parts[0]) && parts.length === 2) id = parts[1];
        }
        if (/^[A-Za-z0-9_-]{11}$/.test(id)) {
          result.provider = 'YouTube';
          result.embed = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=0&playsinline=1';
          result.external = 'https://www.youtube.com/watch?v=' + id;
          result.privacy = 'https://policies.google.com/privacy?hl=de';
          return result;
        }

        if (!['vimeo.com', 'www.vimeo.com', 'player.vimeo.com'].includes(host)) return result;
        let hash = url.searchParams.get('h') || '';
        if (host === 'player.vimeo.com' && parts[0] === 'video' && parts.length === 2) {
          id = parts[1];
        } else if (host !== 'player.vimeo.com') {
          if (/^\d+$/.test(parts[0] || '') && parts.length <= 2) {
            id = parts[0];
            hash = hash || parts[1] || '';
          } else if (parts[0] === 'channels' && parts.length === 3) {
            id = parts[2];
          } else if (parts[0] === 'groups' && parts[2] === 'videos' && parts.length === 4) {
            id = parts[3];
          } else if (parts[0] === 'showcase' && parts[2] === 'video' && parts.length === 4) {
            id = parts[3];
          }
        }
        if (!/^\d{1,20}$/.test(id) || (hash && !/^[A-Za-z0-9_-]{1,128}$/.test(hash))) return result;
        const embed = new URL('https://player.vimeo.com/video/' + id);
        if (hash) embed.searchParams.set('h', hash);
        embed.searchParams.set('dnt', '1');
        embed.searchParams.set('autoplay', '0');
        result.provider = 'Vimeo';
        result.embed = embed.href;
        result.external = 'https://vimeo.com/' + id + (hash ? '/' + encodeURIComponent(hash) : '');
        result.privacy = 'https://vimeo.com/privacy';
        return result;
      }

      connectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected && !this.listeners) this.initialize();
        });
      }

      disconnectedCallback() {
        this.resetPlayer();
        if (this.listeners) this.listeners.abort();
        this.listeners = null;
      }

      initialize() {
        this.container = this.closest('.pw-profile__video');
        this.stage = this.querySelector('[data-video-stage]');
        this.preview = this.querySelector('[data-video-preview]');
        this.frame = this.querySelector('[data-video-frame]');
        this.gate = this.querySelector('[data-video-gate]');
        this.note = this.querySelector('[data-video-note]');
        this.status = this.querySelector('[data-video-status]');
        this.loadButton = this.querySelector('[data-video-load]');
        this.closeButton = this.querySelector('[data-video-close]');
        this.preferencesButton = this.querySelector('[data-video-preferences]');
        this.externalLink = this.querySelector('[data-video-external]');
        this.privacyLink = this.querySelector('[data-video-privacy]');
        if (!this.container || !this.loadButton || !this.frame) return;
        this.video = PellegriniWineryVideo.parseVideoUrl(this.dataset.videoUrl);
        this.loadTicket = (this.loadTicket || 0) + 1;
        this.listeners = new AbortController();
        const options = { signal: this.listeners.signal };

        if (!this.video) {
          if (this.dataset.editor === 'true') {
            this.stage.hidden = true;
            this.note.textContent = 'Bitte im Feld Videolink eine vollständige HTTP(S)-Adresse ohne Zugangsdaten hinterlegen.';
          } else {
            this.container.hidden = true;
          }
          return;
        }
        this.externalLink.href = this.video.external;
        this.externalLink.hidden = false;
        const externalLabel = this.video.provider ? 'Bei ' + this.video.provider + ' ansehen' : 'Video extern ansehen';
        this.querySelector('[data-video-external-label]').textContent = externalLabel;
        this.externalLink.setAttribute('aria-label', externalLabel + ' (öffnet in einem neuen Tab)');

        if (!this.video.embed) {
          this.note.textContent = 'Dieses Video können Sie direkt beim Anbieter ansehen.';
          return;
        }
        this.note.textContent = 'Mit Klick auf das Vorschaubild („Video abspielen“) stimmen Sie zu, dass ' + this.video.provider +
          ' das Video bereitstellt und dafür Daten wie Ihre IP-Adresse erhält. Der Anbieter kann Cookies verwenden.';
        this.privacyLink.href = this.video.privacy;
        this.privacyLink.hidden = false;
        const privacyLabel = 'Datenschutz bei ' + this.video.provider;
        this.querySelector('[data-video-privacy-label]').textContent = privacyLabel;
        this.privacyLink.setAttribute('aria-label', privacyLabel + ' (öffnet in einem neuen Tab)');
        this.loadButton.hidden = false;
        this.loadButton.disabled = false;
        this.loadButton.setAttribute('aria-label', 'Video abspielen: ' + this.dataset.wineryLabel + ' (' + this.video.provider + ')');
        const placeholder = this.querySelector('[data-video-placeholder]');
        if (placeholder) placeholder.hidden = true;
        if (this.dataset.consentMode === 'shopify') {
          this.note.textContent += ' Zusätzlich ist die Freigabe der Marketing-Cookies in den Datenschutzeinstellungen erforderlich.';
        }
        this.refreshPreferencesButton();

        this.loadButton.addEventListener('click', () => this.loadPlayer(), options);
        this.closeButton.addEventListener('click', () => this.resetPlayer(true), options);
        this.preferencesButton.addEventListener('click', () => this.showPreferences(), options);
        this.addEventListener('focusin', () => this.refreshPreferencesButton(), options);
        document.addEventListener('visitorConsentCollected', event => {
          this.refreshPreferencesButton();
          if (event.detail && event.detail.marketingAllowed === false) {
            const active = Boolean(this.iframe);
            this.resetPlayer(active);
            if (active) this.setStatus('Das Video wurde nach Änderung Ihrer Datenschutzeinstellungen deaktiviert.');
          }
        }, options);
      }

      refreshPreferencesButton() {
        this.preferencesButton.hidden = !(this.dataset.consentMode === 'shopify' &&
          window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function');
      }

      async showPreferences() {
        if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') return;
        try {
          await window.privacyBanner.showPreferences();
        } catch {
          this.setStatus('Bitte öffnen Sie die Datenschutzeinstellungen über den Cookie-Banner.');
        }
      }

      getPrivacyApi() {
        if (window.Shopify && window.Shopify.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
        if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return Promise.resolve(null);
        return new Promise(resolve => {
          let finished = false;
          const finish = value => {
            if (finished) return;
            finished = true;
            clearTimeout(timeout);
            resolve(value);
          };
          const timeout = setTimeout(() => finish(null), 4000);
          try {
            window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
              finish(error ? null : window.Shopify.customerPrivacy || null);
            });
          } catch {
            finish(null);
          }
        });
      }

      async loadPlayer() {
        if (!this.video || !this.video.embed || this.iframe || this.loadButton.disabled || !this.isConnected) return;
        const ticket = ++this.loadTicket;
        this.loadButton.disabled = true;
        this.setStatus('');

        if (this.dataset.consentMode === 'shopify') {
          const privacy = await this.getPrivacyApi();
          if (ticket !== this.loadTicket || !this.isConnected) return;
          let allowed = false;
          try {
            allowed = Boolean(privacy && typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed());
          } catch {
            allowed = false;
          }
          if (!allowed) {
            this.loadButton.disabled = false;
            this.refreshPreferencesButton();
            this.setStatus(privacy
              ? 'Bitte erlauben Sie Marketing-Cookies in den Datenschutzeinstellungen und klicken Sie danach erneut auf das Vorschaubild. Alternativ können Sie das Video direkt beim Anbieter ansehen.'
              : 'Die Datenschutzeinstellungen konnten nicht geprüft werden. Sie können das Video über den externen Link beim Anbieter ansehen.');
            return;
          }
        }
        if (ticket !== this.loadTicket || !this.isConnected) return;
        const iframe = document.createElement('iframe');
        iframe.title = 'Weingut im Film – ' + this.dataset.wineryLabel + ' (' + this.video.provider + ')';
        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        iframe.setAttribute('tabindex', '0');
        iframe.width = '1000';
        iframe.height = '563';
        const playbackUrl = new URL(this.video.embed);
        playbackUrl.searchParams.set('autoplay', '1');
        iframe.addEventListener('load', () => {
          if (this.iframe === iframe) this.setStatus('');
        }, { once: true });
        iframe.src = playbackUrl.href;
        this.iframe = iframe;
        this.frame.replaceChildren(iframe);
        this.frame.hidden = false;
        this.preview.hidden = true;
        this.gate.hidden = true;
        this.closeButton.hidden = false;
        this.setStatus('Video wird geladen …');
        iframe.focus({ preventScroll: true });
      }

      resetPlayer(focusButton = false) {
        this.loadTicket = (this.loadTicket || 0) + 1;
        if (this.frame) {
          this.frame.replaceChildren();
          this.frame.hidden = true;
        }
        this.iframe = null;
        if (this.preview) this.preview.hidden = false;
        if (this.gate) this.gate.hidden = false;
        if (this.closeButton) this.closeButton.hidden = true;
        if (this.loadButton) this.loadButton.disabled = false;
        this.setStatus('');
        if (focusButton && this.loadButton && !this.loadButton.hidden) this.loadButton.focus({ preventScroll: true });
      }

      setStatus(message) {
        if (!this.status) return;
        this.status.textContent = message;
        this.status.hidden = !message;
      }
    }
    customElements.define('pw-winery-video', PellegriniWineryVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pellegrini-weinwissen"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pellegrini-wine-knowledge')) {
    customElements.define(
      'pellegrini-wine-knowledge',
      class extends HTMLElement {
        connectedCallback() {
          this.querySelectorAll('.spg-ww__quality-copy').forEach(container => {
            if (container.dataset.knowledgeReady) return;

            const source = container.querySelector('.metafield-rich_text_field');
            if (!source) return;

            const groups = [];
            const leading = [];
            let current;

            Array.from(source.children).forEach(block => {
              let title;

              if (/^H[2-6]$/.test(block.tagName)) {
                title = block;
              }

              if (block.tagName === 'P') {
                const nodes = Array.from(block.childNodes);

                const first = nodes.find(node =>
                  node.nodeType === Node.ELEMENT_NODE ||
                  node.textContent.trim()
                );

                if (
                  first?.nodeType === Node.ELEMENT_NODE &&
                  ['STRONG', 'B'].includes(first.tagName) &&
                  !first.querySelector('a')
                ) {
                  const remainder = nodes.slice(nodes.indexOf(first) + 1);

                  const standalone = remainder.every(node =>
                    node.nodeName === 'BR' ||
                    (
                      !node.textContent.trim() &&
                      node.nodeType === Node.TEXT_NODE
                    )
                  );

                  const next = remainder.find(node =>
                    node.nodeType === Node.ELEMENT_NODE ||
                    node.textContent.trim()
                  );

                  if (standalone || next?.nodeName === 'BR') {
                    title = first;
                  }
                }
              }

              if (title?.textContent.trim()) {
                current = {
                  title: title.textContent.trim(),
                  body: []
                };

                groups.push(current);

                if (title !== block) {
                  const remainder = block.cloneNode(true);
                  remainder.firstElementChild.remove();

                  while (
                    remainder.firstChild &&
                    (
                      remainder.firstChild.nodeName === 'BR' ||
                      (
                        remainder.firstChild.nodeType === Node.TEXT_NODE &&
                        !remainder.firstChild.textContent.trim()
                      )
                    )
                  ) {
                    remainder.firstChild.remove();
                  }

                  if (
                    remainder.textContent.trim() ||
                    remainder.querySelector('img, video, iframe')
                  ) {
                    current.body.push(remainder);
                  }
                }
              } else if (current) {
                current.body.push(block.cloneNode(true));
              } else {
                leading.push(block.cloneNode(true));
              }
            });

            if (
              !groups.length ||
              groups.some(group =>
                !group.body.some(block =>
                  block.textContent.trim() ||
                  block.querySelector('img, video, iframe')
                )
              )
            ) {
              return;
            }

            const grid = document.createElement('div');
            grid.className = 'spg-ww__knowledge-grid';

            groups.forEach(group => {
              const card = document.createElement('div');
              card.className = 'spg-ww__knowledge-card';

              const heading = document.createElement('h3');
              heading.className = 'h6 spg-ww__knowledge-title';
              heading.textContent = group.title;

              const body = document.createElement('div');
              body.className = 'prose spg-ww__knowledge-body';
              body.append(...group.body);

              card.append(heading, body);
              grid.append(card);
            });

            source.replaceChildren(...leading, grid);
            container.dataset.knowledgeReady = 'true';
          });

          this.querySelectorAll('[data-ww-video]').forEach(panel => {
            if (panel.dataset.ready) return;

            let id;

            try {
              const url = new URL(panel.dataset.wwVideo);
              const host = url.hostname.toLowerCase();

              if (url.protocol !== 'https:') return;

              if (host === 'youtu.be') {
                id = url.pathname.split('/')[1];
              } else if (
                [
                  'youtube.com',
                  'www.youtube.com',
                  'm.youtube.com',
                  'youtube-nocookie.com',
                  'www.youtube-nocookie.com'
                ].includes(host)
              ) {
                const parts = url.pathname.split('/').filter(Boolean);

                if (parts[0] === 'watch') {
                  id = url.searchParams.get('v');
                } else if (['embed', 'shorts', 'live'].includes(parts[0])) {
                  id = parts[1];
                }
              }
            } catch {
              return;
            }

            if (!/^[A-Za-z0-9_-]{11}$/.test(id || '')) return;

            const stage = panel.querySelector('[data-ww-video-stage]');
            const button = panel.querySelector('[data-ww-video-load] button');
            const source = panel.querySelector('[data-ww-video-source]');

            if (!stage || !button || !source) return;

            source.href = 'https://www.youtube.com/watch?v=' + id;
            panel.hidden = false;
            panel.dataset.ready = 'true';

            stage.addEventListener('click', () => {
              const iframe = document.createElement('iframe');

              iframe.title = stage.dataset.videoTitle;
              iframe.width = '1600';
              iframe.height = '900';
              iframe.allow =
                'autoplay; encrypted-media; picture-in-picture; fullscreen';
              iframe.allowFullscreen = true;
              iframe.referrerPolicy = 'strict-origin-when-cross-origin';
              iframe.src =
                'https://www.youtube-nocookie.com/embed/' +
                id +
                '?autoplay=1&playsinline=1&rel=0';

              stage.replaceChildren(iframe);

              const notice = panel.querySelector('[data-ww-video-notice]');
              if (notice) notice.hidden = true;

              iframe.focus();
            }, { once: true });
          });

          this.querySelectorAll('[data-ww-faq]').forEach(container => {
            if (container.dataset.enhanced) return;

            const source = container.querySelector('.metafield-rich_text_field');
            if (!source) return;

            const paragraphs = Array.from(source.children);

            const valid = paragraphs.length > 0 && paragraphs.every(paragraph => {
              const title = paragraph.firstElementChild;

              return (
                paragraph.tagName === 'P' &&
                title?.tagName === 'STRONG' &&
                title.textContent.trim().endsWith('?') &&
                !title.querySelector('a') &&
                !Array.from(paragraph.childNodes)
                  .slice(
                    0,
                    Array.from(paragraph.childNodes).indexOf(title)
                  )
                  .some(node => node.textContent.trim())
              );
            });

            if (!valid) return;

            const fragment = document.createDocumentFragment();

            paragraphs.forEach((paragraph, index) => {
              const answer = paragraph.cloneNode(true);
              const title = answer.firstElementChild;

              const details = document.createElement('details');
              details.className = 'spg-ww__faq-item';
              details.open = index === 0;

              const summary = document.createElement('summary');
              summary.className = 'spg-ww__faq-summary';

              const label = document.createElement('span');
              label.textContent = title.textContent;

              const icon = document.createElement('span');
              icon.className = 'spg-ww__faq-icon';
              icon.setAttribute('aria-hidden', 'true');

              summary.append(label, icon);
              title.remove();

              while (
                answer.firstChild &&
                (
                  answer.firstChild.nodeName === 'BR' ||
                  !answer.firstChild.textContent.trim()
                )
              ) {
                answer.firstChild.remove();
              }

              if (answer.firstChild?.nodeType === Node.TEXT_NODE) {
                answer.firstChild.textContent =
                  answer.firstChild.textContent.trimStart();
              }

              const body = document.createElement('div');
              body.className = 'spg-ww__faq-answer';
              body.append(answer);

              details.append(summary, body);
              fragment.append(details);
            });

            source.replaceWith(fragment);
            container.dataset.enhanced = 'true';
          });

          const shopUrl = new URL(
            this.dataset.shopUrl || window.location.href
          );

          const shopHosts = [
            window.location.hostname,
            shopUrl.hostname
          ].map(host => host.toLowerCase().replace(/^www\./, ''));

          this.querySelectorAll('a[href]').forEach(link => {
            let url;

            try {
              url = new URL(link.getAttribute('href'), document.baseURI);
            } catch {
              return;
            }

            if (!['http:', 'https:'].includes(url.protocol)) return;

            const host = url.hostname.toLowerCase().replace(/^www\./, '');

            const isYouTube = [
              'youtube.com',
              'youtu.be',
              'youtube-nocookie.com'
            ].some(domain =>
              host === domain || host.endsWith('.' + domain)
            );

            if (isYouTube) {
              link.removeAttribute('target');
              return;
            }

            if (!shopHosts.includes(host)) {
              link.target = '_blank';
              link.relList.add('noopener', 'noreferrer');
            }
          });

          const links = Array.from(
            this.querySelectorAll('.spg-ww__chapter')
          );

          if (!('IntersectionObserver' in window) || !links.length) return;

          this.observer?.disconnect();

          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;

              links.forEach(link => {
                if (link.hash === '#' + entry.target.id) {
                  link.setAttribute('aria-current', 'location');
                } else {
                  link.removeAttribute('aria-current');
                }
              });
            });
          }, {
            rootMargin: '-20% 0px -55% 0px'
          });

          links.forEach(link => {
            const target = document.getElementById(link.hash.slice(1));

            if (target && this.contains(target)) {
              this.observer.observe(target);
            }
          });

          const hero = this.querySelector('.spg-ww__hero');
          if (hero) this.observer.observe(hero);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pellegrini-weitere-weingueter"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pellegrini-related-wineries')) {
    customElements.define('pellegrini-related-wineries', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.updateFrame);
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }

      initialize() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.track = this.querySelector('[data-pwr-track]');
        this.arrows = this.querySelector('[data-pwr-arrows]');
        this.previous = this.querySelector('[data-pwr-prev]');
        this.next = this.querySelector('[data-pwr-next]');
        if (!this.track) return;

        this.controller = new AbortController();
        const signal = this.controller.signal;
        const schedule = () => {
          cancelAnimationFrame(this.updateFrame);
          this.updateFrame = requestAnimationFrame(() => this.update());
        };

        this.previous?.addEventListener('click', () => this.move(-1), { signal });
        this.next?.addEventListener('click', () => this.move(1), { signal });
        this.track.addEventListener('scroll', schedule, { passive: true, signal });
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            const direction = event.key === 'ArrowRight' ? 1 : -1;
            this.move(rtl ? -direction : direction);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            const end = (this.track.scrollWidth - this.track.clientWidth) * (rtl ? -1 : 1);
            this.track.scrollTo({ left: event.key === 'Home' ? 0 : end, behavior: this.scrollBehavior() });
          }
        }, { signal });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(schedule);
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener('resize', schedule, { passive: true, signal });
        }
        this.update();
      }

      scrollBehavior() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }

      move(direction) {
        const firstCard = this.track.firstElementChild;
        if (!firstCard) return;
        const styles = getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap) || 0;
        const step = firstCard.getBoundingClientRect().width + gap;
        const visibleCards = Math.max(1, Math.floor((this.track.clientWidth + gap + 1) / step));
        const sign = styles.direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({ left: direction * sign * step * visibleCards, behavior: this.scrollBehavior() });
      }

      update() {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.max(0, Math.min(maximum, Math.abs(this.track.scrollLeft)));
        const overflows = maximum > 2;
        if (this.arrows) this.arrows.hidden = !overflows;
        if (this.previous) this.previous.disabled = !overflows || position <= 2;
        if (this.next) this.next.disabled = !overflows || position >= maximum - 2;
        this.track.tabIndex = overflows ? 0 : -1;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
